
/* =========================================================
   Deviceli storefront — data
   ========================================================= */
const CATS = [
  {id:'iphone', label:'iPhone',  art:'p16_green'},
  {id:'android',label:'Samsung', art:'s26u_black'},
  {id:'ipad',   label:'iPad',    art:'ipadair_blue'},
  {id:'mac',    label:'MacBook', art:'mbp14_black'},
  {id:'watch',  label:'Watch',   art:'watch_silver'},
  {id:'gaming', label:'Gaming',  art:'ps5_slim'},
  {id:'audio',  label:'AirPods', art:'airpods3'}
];

const GRADES = {
  excellent:{label:'Excellent', pip:'',      note:'Almost no signs of use. Flawless screen, micro-scratches on the body invisible from 20 cm.', mult:1},
  good:     {label:'Good',      pip:'good',  note:'Light signs of use. Flawless screen, light micro-scratches on the body invisible from 50 cm.', mult:0.91},
  fair:     {label:'Fair',      pip:'fair',  note:'Visible signs of use. Scratches or small dents on the body, light screen scratches visible only when it is on.', mult:0.82}
};

const P = [
  {id:'ip18pm', name:'iPhone 18 Pro Max', brand:'Apple', cat:'iphone', art:'p18pro_black', price:1599, msrp:2049,
   storage:['256GB','512GB','1TB'],
   colors:[['Deep Blue','p18pro_blue'],['Burgundy','p18pro_red'],['Silver','p18pro_white'],['Black','p18pro_black']],
   specs:{Display:'6.9" Super Retina XDR',Chip:'A20 Pro',Camera:'48MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:2},

  {id:'ip18p', name:'iPhone 18 Pro', brand:'Apple', cat:'iphone', art:'p18pro_blue', price:1449, msrp:1849,
   storage:['256GB','512GB','1TB'],
   colors:[['Deep Blue','p18pro_blue'],['Burgundy','p18pro_red'],['Silver','p18pro_white'],['Black','p18pro_black']],
   specs:{Display:'6.3" Super Retina XDR',Chip:'A20 Pro',Camera:'48MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:3},

  {id:'s26u', name:'Galaxy S26 Ultra', brand:'Samsung', cat:'android', art:'s26u_violet', price:1199, msrp:1749,
   storage:['256GB','512GB','1TB'],
   colors:[['Violet','s26u_violet'],['Light Blue','s26u_blue'],['Black','s26u_black']],
   specs:{Display:'6.9" Dynamic AMOLED 2X',Chip:'Snapdragon 8 Elite Gen 5',Camera:'200MP quad',Battery:'80% or better',Network:'Unlocked'}, stock:2},

  {id:'s25p', name:'Galaxy S25+', brand:'Samsung', cat:'android', art:'s25_icyblue', price:749, msrp:1409,
   storage:['256GB','512GB'],
   colors:[['Icyblue','s25_icyblue','#C9D8EE'],['Navy','s25_navy','#1F3A7A'],['Mint','s25_mint','#CDEBDD'],['Silver Shadow','s25_shadow','#3B3F48']],
   specs:{Display:'6.7" Dynamic AMOLED 2X, 120Hz',Chip:'Snapdragon 8 Elite for Galaxy',Camera:'50MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:3, blurb:"The big-screen S25 with the same flagship chip and Galaxy AI, and Samsung's promise of seven years of Android updates.", high:[["6.7-inch QHD+ display", "Sharp, bright and smooth at 120Hz."], ["Snapdragon 8 Elite", "The fastest chip Samsung shipped that year."], ["7 years of updates", "Android and security updates for years to come."]], box:"Phone, USB-C cable, SIM tool"},

  {id:'s25', name:'Galaxy S25', brand:'Samsung', cat:'android', art:'s25_navy', price:649, msrp:1189,
   storage:['128GB','256GB'],
   colors:[['Navy','s25_navy','#1F3A7A'],['Icyblue','s25_icyblue','#C9D8EE'],['Mint','s25_mint','#CDEBDD'],['Silver Shadow','s25_shadow','#3B3F48']],
   specs:{Display:'6.2" Dynamic AMOLED 2X, 120Hz',Chip:'Snapdragon 8 Elite for Galaxy',Camera:'50MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:4, blurb:"A flagship that fits in one hand. Top chip, great cameras and seven years of Android updates.", high:[["Compact 6.2-inch display", "Easy to use with one hand."], ["50MP triple camera", "Wide, ultra wide and 3x telephoto."], ["7 years of updates", "Android and security updates for years to come."]], box:"Phone, USB-C cable, SIM tool"},

  {id:'s24p', name:'Galaxy S24+', brand:'Samsung', cat:'android', art:'s24_grey', price:599, msrp:1399,
   storage:['256GB','512GB'],
   colors:[['Marble Grey','s24_grey','#C9C9CB'],['Onyx Black','s24_black','#2A2A2C']],
   specs:{Display:'6.7" Dynamic AMOLED 2X, 120Hz',Chip:'Snapdragon 8 Gen 3 for Galaxy',Camera:'50MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:3, blurb:"The first Galaxy with Galaxy AI built in, a QHD+ screen and a big battery, now at a much friendlier price.", high:[["6.7-inch QHD+ display", "Bright enough for direct sun."], ["Galaxy AI", "Live translate, Circle to Search and photo editing."], ["7 years of updates", "Supported well into the next decade."]], box:"Phone, USB-C cable, SIM tool"},

  {id:'s24', name:'Galaxy S24', brand:'Samsung', cat:'android', art:'s24_black', price:499, msrp:1099,
   storage:['128GB','256GB'],
   colors:[['Onyx Black','s24_black','#2A2A2C'],['Marble Grey','s24_grey','#C9C9CB']],
   specs:{Display:'6.2" Dynamic AMOLED 2X, 120Hz',Chip:'Snapdragon 8 Gen 3 for Galaxy',Camera:'50MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:5, blurb:"Small, fast and packed with Galaxy AI. One of the best compact Android phones you can buy used.", high:[["Compact 6.2-inch display", "Pocket friendly."], ["Galaxy AI", "Circle to Search, live translate and more."], ["7 years of updates", "Android and security updates for years."]], box:"Phone, USB-C cable, SIM tool"},

  {id:'s23p', name:'Galaxy S23+', brand:'Samsung', cat:'android', art:'s23_green', price:449, msrp:1399,
   storage:['256GB','512GB'],
   colors:[['Green','s23_green','#5B6653'],['Phantom Black','s23_black','#232325']],
   specs:{Display:'6.6" Dynamic AMOLED 2X, 120Hz',Chip:'Snapdragon 8 Gen 2 for Galaxy',Camera:'50MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:3, blurb:"A big screen, excellent battery life and a chip that still feels quick, at well under half its launch price.", high:[["6.6-inch display", "Plenty of room without the Ultra size."], ["4,700 mAh battery", "Comfortably a full day."], ["Snapdragon 8 Gen 2", "Fast and efficient."]], box:"Phone, USB-C cable, SIM tool"},

  {id:'s23', name:'Galaxy S23', brand:'Samsung', cat:'android', art:'s23_black', price:379, msrp:1099,
   storage:['128GB','256GB'],
   colors:[['Phantom Black','s23_black','#232325'],['Green','s23_green','#5B6653']],
   specs:{Display:'6.1" Dynamic AMOLED 2X, 120Hz',Chip:'Snapdragon 8 Gen 2 for Galaxy',Camera:'50MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:5, blurb:"The small Galaxy flagship at a great price. Fast, well built and a strong camera for everyday photos.", high:[["Compact 6.1-inch display", "Light and easy to hold."], ["50MP triple camera", "Wide, ultra wide and 3x telephoto."], ["Snapdragon 8 Gen 2", "Smooth for apps and games."]], box:"Phone, USB-C cable, SIM tool"},

  {id:'ip16pm', name:'iPhone 16 Pro Max', brand:'Apple', cat:'iphone', art:'p16pro_black', price:1099, msrp:1749,
   storage:['256GB','512GB','1TB'],
   colors:[['Black Titanium','p16pro_black'],['Natural Titanium','p16pro_natural'],['White Titanium','p16pro_white'],['Desert Titanium','p16pro_desert']],
   specs:{Display:'6.9" Super Retina XDR',Chip:'A18 Pro',Camera:'48MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:4},

  {id:'ip16pro', name:'iPhone 16 Pro', brand:'Apple', cat:'iphone', art:'p16pro_desert', price:949, msrp:1449,
   storage:['128GB','256GB','512GB','1TB'],
   colors:[['Desert Titanium','p16pro_desert'],['Natural Titanium','p16pro_natural'],['White Titanium','p16pro_white'],['Black Titanium','p16pro_black']],
   specs:{Display:'6.3" Super Retina XDR',Chip:'A18 Pro',Camera:'48MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:6},

  {id:'ip15pm', name:'iPhone 15 Pro Max', brand:'Apple', cat:'iphone', art:'p15pro_natural', price:899, msrp:1649,
   storage:['256GB','512GB','1TB'],
   colors:[['Natural Titanium','p15pro_natural'],['Blue Titanium','p15pro_blue'],['White Titanium','p15pro_white'],['Black Titanium','p15pro_black']],
   specs:{Display:'6.7" Super Retina XDR',Chip:'A17 Pro',Camera:'48MP triple, 5x zoom',Battery:'80% or better',Network:'Unlocked'}, stock:5},

  {id:'ip15pro', name:'iPhone 15 Pro', brand:'Apple', cat:'iphone', art:'p15pro_blue', price:799, msrp:1449,
   storage:['128GB','256GB','512GB','1TB'],
   colors:[['Blue Titanium','p15pro_blue'],['Natural Titanium','p15pro_natural'],['White Titanium','p15pro_white'],['Black Titanium','p15pro_black']],
   specs:{Display:'6.1" Super Retina XDR',Chip:'A17 Pro',Camera:'48MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:7},

  {id:'ip16plus', name:'iPhone 16 Plus', brand:'Apple', cat:'iphone', art:'p16_white', price:899, msrp:1249,
   storage:['128GB','256GB','512GB'],
   colors:[['White','p16_white'],['Black','p16_black'],['Teal','p16_green'],['Ultramarine','p16_violet'],['Pink','p16_pink']],
   specs:{Display:'6.7" Super Retina XDR',Chip:'A18',Camera:'48MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:3},

  {id:'ip17p', name:'iPhone 17 Pro', brand:'Apple', cat:'iphone', art:'p17pro_blue', price:1249, msrp:1649,
   storage:['256GB','512GB','1TB'],
   colors:[['Deep Blue','p17pro_blue'],['Cosmic Orange','p17pro_orange'],['Silver','p17pro_white']],
   specs:{Display:'6.3" Super Retina XDR',Chip:'A19 Pro',Camera:'48MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:4, blurb:"The 17 Pro is the one people keep for four years. Titanium frame, the best camera Apple has shipped, and a chip that will not feel slow in 2029.", high:[["A19 Pro chip", "Handles anything you throw at it, and will keep doing so for years."], ["48MP triple camera", "Optical zoom that actually resolves detail, not digital mush."], ["Titanium body", "Lighter than the steel Pros and far harder to bend."]], box:"Phone, USB-C cable, SIM tool"},

  {id:'ip16', name:'iPhone 16', brand:'Apple', cat:'iphone', art:'p16_black', price:789, msrp:1129,
   storage:['128GB','256GB','512GB'],
   colors:[['Black','p16_black'],['Teal','p16_green'],['Ultramarine','p16_violet'],['White','p16_white'],['Pink','p16_pink']],
   specs:{Display:'6.1" Super Retina XDR',Chip:'A18',Camera:'48MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:9, blurb:"The standard iPhone that finally got the Pro features. Dynamic Island, 48MP camera, USB-C. For most people this is the right amount of phone.", high:[["48MP main camera", "Detailed shots plus a 2x zoom with no quality loss."], ["Dynamic Island", "Alerts and timers live at the top of the screen instead of interrupting you."], ["USB-C", "One cable for the phone, the iPad and the laptop."]], box:"Phone, USB-C cable, SIM tool"},

  {id:'ip15', name:'iPhone 15', brand:'Apple', cat:'iphone', art:'p15_blue', price:649, msrp:1129,
   storage:['128GB','256GB','512GB'],
   colors:[['Blue','p15_blue','#CFDDE6'],['Pink','p15_pink','#EDCFD4'],['Yellow','p15_yellow','#EFE6B8'],['Green','p15_green','#CDDBC8']],
   specs:{Display:'6.1" Super Retina XDR',Chip:'A16 Bionic',Camera:'48MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:6, blurb:"The first iPhone with USB-C and Dynamic Island on the regular model. One cable for your phone, iPad and Mac.", high:[["48MP main camera", "Sharper photos and a 2x zoom that looks like a real lens."], ["Dynamic Island", "Live activities, timers and calls at the top of the screen."], ["USB-C", "Charges with the same cable as your Mac and iPad."]], box:"Phone, USB-C cable, SIM tool"},

  {id:'ip15plus', name:'iPhone 15 Plus', brand:'Apple', cat:'iphone', art:'p15_pink', price:729, msrp:1279,
   storage:['128GB','256GB','512GB'],
   colors:[['Pink','p15_pink','#EDCFD4'],['Blue','p15_blue','#CFDDE6'],['Yellow','p15_yellow','#EFE6B8'],['Green','p15_green','#CDDBC8']],
   specs:{Display:'6.7" Super Retina XDR',Chip:'A16 Bionic',Camera:'48MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:4, blurb:"The big screen without the Pro price, and one of the longest-lasting batteries Apple has made.", high:[["6.7-inch display", "More room for video, maps and reading."], ["All-day battery", "Easily a full day, often two."], ["USB-C", "One cable for everything."]], box:"Phone, USB-C cable, SIM tool"},

  {id:'ip14pm', name:'iPhone 14 Pro Max', brand:'Apple', cat:'iphone', art:'p14pro_black', price:779, msrp:1549,
   storage:['128GB','256GB','512GB','1TB'],
   colors:[['Space Black','p14pro_black'],['Deep Purple','p14pro_purple'],['Gold','p14pro_gold','#E6D6B8'],['Silver','p14pro_silver']],
   specs:{Display:'6.7" Super Retina XDR',Chip:'A16 Bionic',Camera:'48MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:3, blurb:"The biggest Pro screen of its year, Always-On display and a 48MP camera, at well under half its launch price.", high:[["6.7-inch Always-On display", "Big, bright and readable in the sun."], ["48MP triple camera", "Main, ultra wide and 3x telephoto."], ["Pro battery", "The longest battery life of the 14 line."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ip14plus', name:'iPhone 14 Plus', brand:'Apple', cat:'iphone', art:'p14_purple', price:599, msrp:1249,
   storage:['128GB','256GB','512GB'],
   colors:[['Purple','p14_purple','#D9CFE8'],['Blue','p14_blue','#A9BCD3'],['Starlight','p14_starlight'],['(PRODUCT)RED','p14_red','#C8102E']],
   specs:{Display:'6.7" Super Retina XDR',Chip:'A15 Bionic',Camera:'12MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:5, blurb:"A big screen and a battery that lasts, for a lot less than a Pro Max.", high:[["6.7-inch display", "The same size as the Pro Max."], ["Long battery life", "Built for heavy days."], ["Crash Detection and Emergency SOS", "Safety features that were new on the 14."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ip14', name:'iPhone 14', brand:'Apple', cat:'iphone', art:'p14_blue', price:529, msrp:1099,
   storage:['128GB','256GB','512GB'],
   colors:[['Blue','p14_blue','#A9BCD3'],['Starlight','p14_starlight'],['Purple','p14_purple','#D9CFE8'],['(PRODUCT)RED','p14_red','#C8102E']],
   specs:{Display:'6.1" Super Retina XDR',Chip:'A15 Bionic',Camera:'12MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:8, blurb:"A fast, compact iPhone with years of updates ahead of it, at a price that makes sense.", high:[["A15 Bionic", "Smooth with every app you use."], ["Dual 12MP camera", "Better low light than the 13."], ["Crash Detection", "Calls for help if you are in a serious car crash."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ip14p', name:'iPhone 14 Pro', brand:'Apple', cat:'iphone', art:'p14pro_purple', price:729, msrp:1399,
   storage:['128GB','256GB','512GB','1TB'],
   colors:[['Deep Purple','p14pro_purple'],['Space Black','p14pro_black'],['Gold','p14pro_gold','#E6D6B8'],['Silver','p14pro_silver']],
   specs:{Display:'6.1" Super Retina XDR',Chip:'A16 Bionic',Camera:'48MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:6, blurb:"Still a Pro. Always-On display, 48MP camera and a body that has aged better than its price.", high:[["Always-On display", "Time and notifications visible without touching anything."], ["48MP triple camera", "Three lenses, real optical zoom, night mode that works."], ["A16 Bionic", "Three years old and still faster than most phones sold new today."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ip13pm', name:'iPhone 13 Pro Max', brand:'Apple', cat:'iphone', art:'p13pro_blue', price:649, msrp:1549,
   storage:['128GB','256GB','512GB','1TB'],
   colors:[['Sierra Blue','p13pro_blue','#9BB5CE'],['Graphite','p13pro_graphite','#54524F'],['Alpine Green','p13pro_green','#4E5D4C'],['Silver','p13pro_silver']],
   specs:{Display:'6.7" Super Retina XDR, 120Hz',Chip:'A15 Bionic',Camera:'12MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:4, blurb:"ProMotion, a triple camera and one of the best batteries of any iPhone, for about the price of a new mid-range phone.", high:[["ProMotion 120Hz", "Scrolling and games feel smoother."], ["Triple camera with 3x zoom", "Macro, night mode and Cinematic mode video."], ["Big battery", "The longest-lasting iPhone of its year."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ip13pro', name:'iPhone 13 Pro', brand:'Apple', cat:'iphone', art:'p13pro_graphite', price:579, msrp:1399,
   storage:['128GB','256GB','512GB','1TB'],
   colors:[['Graphite','p13pro_graphite','#54524F'],['Sierra Blue','p13pro_blue','#9BB5CE'],['Alpine Green','p13pro_green','#4E5D4C'],['Silver','p13pro_silver']],
   specs:{Display:'6.1" Super Retina XDR, 120Hz',Chip:'A15 Bionic',Camera:'12MP triple',Battery:'80% or better',Network:'Unlocked'}, stock:5, blurb:"A Pro camera and a 120Hz screen in a size that fits the hand, at a fraction of its launch price.", high:[["ProMotion 120Hz", "The first iPhone with a 120Hz display."], ["Triple camera with 3x zoom", "Telephoto, ultra wide and macro."], ["Stainless steel frame", "The Pro build, surgical-grade steel."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ip13', name:'iPhone 13', brand:'Apple', cat:'iphone', art:'p13_blue', price:479, msrp:1099,
   storage:['128GB','256GB','512GB'],
   colors:[['Blue','p13_blue'],['Midnight','p13_midnight'],['Starlight','p13_starlight'],['Green','p13_green','#3C5B45'],['(PRODUCT)RED','p13_red','#BF1E2E']],
   specs:{Display:'6.1" Super Retina XDR',Chip:'A15 Bionic',Camera:'12MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:12, blurb:"The value pick. Fast enough for everything, small enough for one hand, and years of iOS updates ahead of it.", high:[["A15 Bionic", "Runs current iOS without hesitation."], ["Dual 12MP camera", "Sensor-shift stabilisation, the same system as the 13 Pro."], ["All-day battery", "Every unit leaves at 80% health or better."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ip13mini', name:'iPhone 13 mini', brand:'Apple', cat:'iphone', art:'p13_midnight', price:429, msrp:979,
   storage:['128GB','256GB','512GB'],
   colors:[['Midnight','p13_midnight'],['Blue','p13_blue'],['Starlight','p13_starlight'],['Green','p13_green','#3C5B45'],['(PRODUCT)RED','p13_red','#BF1E2E']],
   specs:{Display:'5.4" Super Retina XDR',Chip:'A15 Bionic',Camera:'12MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:5, blurb:"The last small iPhone, and still the best one-handed phone you can buy. Full power in a pocket-sized body.", high:[["5.4-inch display", "Fits any pocket and every thumb."], ["A15 Bionic", "The same chip as the iPhone 13."], ["Dual 12MP camera", "Sensor-shift stabilisation for steadier shots."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ip12', name:'iPhone 12', brand:'Apple', cat:'iphone', art:'p12_black', price:329, msrp:1129,
   storage:['64GB','128GB','256GB'],
   colors:[['Black','p12_black'],['Blue','p12_blue','#1F3F66'],['White','p12_white'],['(PRODUCT)RED','p12_red','#D8262F']],
   specs:{Display:'6.1" Super Retina XDR',Chip:'A14 Bionic',Camera:'12MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:7, blurb:"The cheapest way into a modern iPhone. 5G, OLED screen, Face ID, MagSafe. Nothing essential is missing.", high:[["OLED display", "Proper blacks and brightness, not the old LCD panel."], ["5G", "Works on every Canadian network."], ["MagSafe", "Magnetic chargers, wallets and mounts all click on."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ip12mini', name:'iPhone 12 mini', brand:'Apple', cat:'iphone', art:'p12_blue', price:289, msrp:999,
   storage:['64GB','128GB','256GB'],
   colors:[['Blue','p12_blue','#1F3F66'],['Black','p12_black'],['White','p12_white'],['(PRODUCT)RED','p12_red','#D8262F']],
   specs:{Display:'5.4" Super Retina XDR',Chip:'A14 Bionic',Camera:'12MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:4, blurb:"Small, light and complete. OLED, 5G, Face ID and MagSafe in the smallest modern iPhone.", high:[["5.4-inch OLED", "A full-screen iPhone that disappears in a pocket."], ["5G", "Works on every Canadian network."], ["MagSafe", "Magnetic chargers and wallets click on."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ip11', name:'iPhone 11', brand:'Apple', cat:'iphone', art:'p11_black', price:229, msrp:979,
   storage:['64GB','128GB','256GB'],
   colors:[['Black','p11_black'],['White','p11_white'],['Green','p11_green','#BFE3D0'],['Yellow','p11_yellow','#F5E27A'],['Purple','p11_purple','#D6CCEB'],['(PRODUCT)RED','p11_red','#C8102E']],
   specs:{Display:'6.1" Liquid Retina',Chip:'A13 Bionic',Camera:'12MP dual',Battery:'80% or better',Network:'Unlocked'}, stock:6, blurb:"The simplest way to get an iPhone that still runs the latest iOS. Night mode, ultra wide camera and Face ID.", high:[["Dual camera with ultra wide", "Fit more into every shot."], ["Night mode", "Usable photos in low light."], ["Face ID", "Unlocks with a glance."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ipxr', name:'iPhone XR', brand:'Apple', cat:'iphone', art:'pxr_blue', price:179, msrp:1029,
   storage:['64GB','128GB','256GB'],
   colors:[['Blue','pxr_blue','#5FB3E8'],['Black','pxr_black'],['White','pxr_white'],['Yellow','pxr_yellow','#F6D34A'],['(PRODUCT)RED','pxr_red','#C8102E']],
   specs:{Display:'6.1" Liquid Retina',Chip:'A12 Bionic',Camera:'12MP single',Battery:'80% or better',Network:'Unlocked'}, stock:4, blurb:"An easy first iPhone or a solid backup. Face ID, a big screen and a price that is hard to argue with. It runs iOS 18 and no longer gets new major iOS versions.", high:[["6.1-inch display", "Big, bright and easy to read."], ["Face ID", "Secure and fast."], ["iOS 18", "Security updates continue, but no new major versions."]], box:"Phone, Lightning cable, SIM tool"},

  {id:'ipadairm3', name:'iPad Air 11" (M3)', brand:'Apple', cat:'ipad', art:'ipadair_purple', price:649, msrp:799,
   storage:['128GB','256GB','512GB','1TB'],
   colors:[['Purple','ipadair_purple','#D6C9EC'],['Blue','ipadair_blue','#A9C4DE'],['Space Grey','ipadair_grey','#6E6E73'],['Starlight','ipadair_starlight']],
   specs:{Display:'11" Liquid Retina',Chip:'Apple M3',Camera:'12MP wide',Connectivity:'Wi-Fi',Included:'USB-C cable'}, stock:4, blurb:"The 2025 iPad Air. M3 power, Apple Intelligence and support for Apple Pencil Pro and the Magic Keyboard.", high:[["Apple M3 chip", "Laptop-class speed for editing, drawing and multitasking."], ["Apple Intelligence", "Writing tools, Image Playground and a smarter Siri."], ["Pencil Pro and Magic Keyboard", "A notebook or a laptop when you need one."]], box:"iPad, USB-C cable"},

  {id:'ipadmini7', name:'iPad mini (A17 Pro)', brand:'Apple', cat:'ipad', art:'ipadmini_grey', price:549, msrp:699,
   storage:['128GB','256GB','512GB'],
   colors:[['Space Grey','ipadmini_grey','#6E6E73'],['Blue','ipadmini_blue','#BCD6DA'],['Purple','ipadmini_purple','#D6CCE6'],['Starlight','ipadmini_starlight']],
   specs:{Display:'8.3" Liquid Retina',Chip:'A17 Pro',Camera:'12MP wide',Connectivity:'Wi-Fi',Included:'USB-C cable'}, stock:4, blurb:"The small iPad, 2024 edition. Fits in a jacket pocket, runs Apple Intelligence and works with Apple Pencil Pro.", high:[["8.3-inch display", "Perfect for reading, notes and travel."], ["A17 Pro chip", "The chip from iPhone 15 Pro."], ["Apple Pencil Pro", "Squeeze, barrel roll and hover."]], box:"iPad, USB-C cable"},

  {id:'ipad11', name:'iPad (A16)', brand:'Apple', cat:'ipad', art:'ipad_blue', price:399, msrp:499,
   storage:['128GB','256GB','512GB'],
   colors:[['Blue','ipad_blue','#8FB3DB'],['Pink','ipad_pink','#E57C93'],['Yellow','ipad_yellow','#F3DA53']],
   specs:{Display:'11" Liquid Retina',Chip:'A16',Camera:'12MP wide',Connectivity:'Wi-Fi',Included:'USB-C cable'}, stock:6, blurb:"The everyday iPad, 2025 edition. An 11-inch screen, 128GB to start and a USB-C port. Great for school, streaming and family.", high:[["11-inch Liquid Retina", "Big enough for split screen."], ["A16 chip", "Fast for apps, games and video calls."], ["128GB to start", "Twice the base storage of the previous model."]], box:"iPad, USB-C cable"},

  {id:'ipadair', name:'iPad Air (M2)', brand:'Apple', cat:'ipad', art:'ipadair_blue', price:549, msrp:799,
   storage:['128GB','256GB'],
   colors:[['Blue','ipadair_blue','#A9C4DE'],['Space Grey','ipadair_grey','#6E6E73'],['Starlight','ipadair_starlight'],['Purple','ipadair_purple','#D6C9EC']],
   specs:{Display:'11" Liquid Retina',Chip:'Apple M2',Camera:'12MP wide',Connectivity:'Wi-Fi',Included:'USB-C cable'}, stock:5, blurb:"The iPad most people should buy. M2 power in a thin body, and it takes the Apple Pencil Pro.", high:[["Apple M2 chip", "The same silicon as a MacBook Air. Editing and drawing never stutter."], ["11-inch Liquid Retina", "Laminated, anti-reflective, comfortable for hours."], ["Pencil and keyboard ready", "Turns into a notebook or a laptop when you need it."]], box:"iPad, USB-C cable"},

  {id:'mbp14', name:'MacBook Pro 14"', brand:'Apple', cat:'mac', art:'mbp14_black', price:1399, msrp:2299,
   storage:['512GB','1TB'],
   colors:[['Space Black','mbp14_black']],
   specs:{Display:'14.2" Liquid Retina XDR',Chip:'Apple M3 Pro',Memory:'18GB unified',Battery:'80% or better',Ports:'HDMI, SDXC, 3\u00d7 TB4'}, stock:3, blurb:"A Pro machine at a price that stops being absurd once someone else has taken the first-year depreciation.", high:[["M3 Pro chip", "Compiles, renders and exports without the fans screaming."], ["14.2-inch XDR display", "1600 nits of peak brightness and real HDR."], ["Ports back where they belong", "HDMI, SD card and MagSafe, no dongle required."]], box:"Laptop, MagSafe charger, power cable"},

  {id:'aw', name:'Apple Watch Series 9', brand:'Apple', cat:'watch', art:'watch_silver', price:329, msrp:529,
   storage:['41mm','45mm'],
   colors:[['Silver','watch_silver']],
   specs:{Display:'Always-On Retina',Chip:'S9 SiP',Health:'ECG, blood oxygen',Battery:'80% or better',Connectivity:'GPS'}, stock:8, blurb:"The watch that does the health work: ECG, blood oxygen, sleep and crash detection, on a bright always-on screen.", high:[["ECG and blood oxygen", "Medical-grade sensors on your wrist."], ["Always-On Retina", "Glance at the time without lifting your arm."], ["Fresh band included", "Every watch ships with a new band, never the previous owner's."]], box:"Watch, new sport band, magnetic charger"},

  {id:'ap3', name:'AirPods (3rd Gen)', brand:'Apple', cat:'audio', art:'airpods3', price:129, msrp:239,
   storage:['Standard'], colors:[['White','airpods3']],
   specs:{Audio:'Spatial Audio, Adaptive EQ',Chip:'H1',Case:'Lightning charging',Battery:'Up to 6 hrs',Included:'Charging case'}, stock:10, blurb:"Open, wear, done. Spatial Audio and the Apple pairing experience without the in-ear seal some people can't stand.", high:[["Spatial Audio", "Sound that stays put when you turn your head."], ["Sweat and water resistant", "Fine for the gym and the rain."], ["Up to 6 hours", "30 hours total with the case."]], box:"Earbuds, charging case, Lightning cable"},

  {id:'ps5', name:'PlayStation 5 Slim', brand:'Sony', cat:'gaming', art:'ps5_slim', price:479, msrp:649,
   storage:['1TB'], colors:[['White','ps5_slim']],
   specs:{Resolution:'Up to 4K 120Hz',Storage:'1TB SSD',Drive:'Disc edition',Included:'1 DualSense, cables',Warranty:'12 months'}, stock:2, blurb:"The disc edition, so you can still buy games used and sell them on. Tested with a full game before it ships.", high:[["4K at 120Hz", "Ray tracing and high frame rates on a modern TV."], ["1TB SSD", "Loading screens measured in seconds."], ["Disc drive", "Buy, borrow, resell. Digital editions cannot."]], box:"Console, DualSense controller, HDMI, power and USB cables"},

  {id:'ds5', name:'DualSense Controller', brand:'Sony', cat:'gaming', art:'dualsense', price:89, msrp:109,
   storage:['Standard'], colors:[['White','dualsense']],
   specs:{Compatibility:'PS5, PC',Feedback:'Haptic triggers',Battery:'Rechargeable',Connection:'Bluetooth 5.1',Included:'USB-C cable'}, stock:14, blurb:"A second controller changes what the console is for. Tested on real games, not just plugged in.", high:[["Haptic triggers", "Resistance you feel when you draw a bow or hit the brakes."], ["Rechargeable", "No battery hunt mid-session."], ["Works on PC too", "Bluetooth or cable, Steam recognises it instantly."]], box:"Controller, USB-C cable"},

  {id:'portal', name:'PlayStation Portal', brand:'Sony', cat:'gaming', art:'portal', price:239, msrp:299,
   storage:['Standard'], colors:[['White','portal']],
   specs:{Display:'8" LCD 1080p',Use:'Remote Play from PS5',Battery:'Up to 9 hrs',Connection:'Wi-Fi 5',Included:'USB-C cable'}, stock:4, blurb:"Your PS5 on an 8-inch screen anywhere in the house. The controller is built around it, so it feels like the real thing.", high:[["8-inch 1080p screen", "Sharp enough that you forget it is a remote session."], ["Full DualSense controls", "Haptics and adaptive triggers, not a stripped-down pad."], ["Up to 9 hours", "Long enough for a full evening."]], box:"Portal, USB-C cable"},

  {id:'xboxss', name:'Xbox Series S', brand:'Microsoft', cat:'gaming', art:'xboxss', price:269, msrp:379,
   storage:['512GB'], colors:[['White','xboxss']],
   specs:{Resolution:'Up to 1440p 120Hz',Storage:'512GB SSD',Drive:'Digital only',Included:'1 controller, cables',Warranty:'12 months'}, stock:5, blurb:"The cheapest way into current-generation gaming, and the obvious console for a Game Pass household.", high:[["Up to 1440p at 120Hz", "Modern frame rates on a smaller budget."], ["512GB SSD", "Instant resume between several games at once."], ["Tiny and quiet", "Fits on a shelf, barely audible in use."]], box:"Console, controller, HDMI, power cable"},

  {id:'xboxpad', name:'Xbox Wireless Controller', brand:'Microsoft', cat:'gaming', art:'xbox_pad', price:59, msrp:89,
   storage:['Standard'], colors:[['Robot White','xbox_pad']],
   specs:{Compatibility:'Xbox, PC, mobile',Grip:'Textured triggers',Battery:'AA or rechargeable',Connection:'Bluetooth',Included:'None'}, stock:11, blurb:"The controller a lot of PC players buy on purpose. Textured grips, low latency, works with everything.", high:[["Textured triggers and grips", "Keeps hold through a long session."], ["Xbox, PC and mobile", "One controller for all three."], ["Share button", "Clips and screenshots without a menu."]], box:"Controller (batteries not included)"}
];

/* trade-in values used by the Sell flow */
const TRADE = {
  iphone:{label:'iPhone', art:'p16_black', list:[['iPhone 18 Pro Max',1240],['iPhone 18 Pro',1080],['iPhone 17 Pro Max',1020],['iPhone 17 Pro',880],['iPhone 17',640],['iPhone 16 Pro Max',820],['iPhone 16 Pro',700],['iPhone 16 Plus',480],['iPhone 16',520],['iPhone 15 Pro Max',640],['iPhone 15 Pro',520],['iPhone 15',420],['iPhone 14 Pro',540],['iPhone 14',400],['iPhone 13',300],['iPhone 12',180],['iPhone 11',120],['iPhone SE (3rd Gen)',110]]},
  android:{label:'Android phones', art:'s26u_black', list:[['Galaxy S26 Ultra',920],['Galaxy S25 Ultra',760],['Galaxy S24 Ultra',600],['Galaxy S24',330],['Galaxy S23',250],['Galaxy Z Flip6',420],['Galaxy Z Fold6',760],['Galaxy A55',170],['Pixel 9 Pro',540],['Pixel 9',380],['Pixel 8',250],['OnePlus 12',330]]},
  ipad:{label:'iPad', art:'ipadair_blue', list:[['iPad Pro 13" (M4)',760],['iPad Pro 11" (M4)',620],['iPad Air (M2)',360],['iPad Air (5th Gen)',300],['iPad (10th Gen)',210],['iPad (9th Gen)',130],['iPad mini (6th Gen)',230]]},
  mac:{label:'MacBook and Mac', art:'mbp14_black', list:[['MacBook Pro 16" M3 Max',1560],['MacBook Pro 14" M3',1050],['MacBook Air 15" M3',820],['MacBook Air 13" M3',700],['MacBook Air M2',540],['MacBook Air M1',380],['Mac mini (M2)',430],['iMac 24" (M1)',620]]},
  watch:{label:'Smartwatches', art:'watch_silver', list:[['Apple Watch Ultra 2',520],['Apple Watch Series 10',330],['Apple Watch Series 9',200],['Apple Watch Series 8',140],['Apple Watch SE (2nd Gen)',90],['Galaxy Watch7',130],['Pixel Watch 3',150]]},
  audio:{label:'AirPods and headphones', art:'airpods3', list:[['AirPods Pro 3',180],['AirPods Pro 2',120],['AirPods 4',95],['AirPods (3rd Gen)',70],['AirPods Max',290],['Sony WH-1000XM5',180],['Bose QuietComfort Ultra',190],['Galaxy Buds3 Pro',85]]},
  gaming:{label:'Gaming', art:'ps5_slim', list:[['PlayStation 5 Pro',560],['PlayStation 5 Slim',290],['PlayStation Portal',120],['Xbox Series X',270],['Xbox Series S',150],['Nintendo Switch 2',350],['Nintendo Switch OLED',180],['DualSense controller',35],['Xbox controller',30]]},
};



/* =========================================================
   Product photos
   ========================================================= */
var BOXSHOT = '';
var IMG = {};


function art(key,alt,size){
  const s=size||110, src=IMG[key]||'';
  return `<img class="dev" src="${src}" alt="${alt||''}" loading="lazy" style="max-height:${s}px;max-width:100%;width:auto;object-fit:contain">`;
}

/* =========================================================
   State
   ========================================================= */
const state = { cart:[], query:'' };
try{ const c=JSON.parse(localStorage.getItem('dv_cart')||'[]'); if(Array.isArray(c)) state.cart=c; }catch(e){}
let LAST_ROUTE = null, LAST_SELL_KEY = '';
let LAST_PID = null;
let ROUTE = (typeof location!=='undefined' && location.hash && location.hash.startsWith('#/')) ? location.hash : '#/';
function go(hash){
  ROUTE = hash || '#/';
  try { if(location.hash!==ROUTE) location.hash=ROUTE; } catch(e){}
  route();
}
const money = n => 'C$' + n.toLocaleString('en-CA',{maximumFractionDigits:0});
const isCapacity = v => /^\d+(GB|TB)/.test(v);
function storageMult(p,i){ return storageBase(p,i)/p.price; }
function storageBase(p,i){ return (isCapacity(p.storage[0]) && i>0) ? Math.round(p.price*(1+0.10*i)/10)*10-1 : p.price; }
function storageNew(p,i){ return (isCapacity(p.storage[0]) && i>0) ? Math.round(p.msrp*(1+0.10*i)/10)*10-1 : p.msrp; }
const optLine = (i,grade) => [isCapacity(i.storage||'')?i.storage:null, i.color, grade].filter(Boolean).join(' · ');
const gradePrice = (base,g) => Math.round(base * GRADES[g].mult);
const FREE_SHIP = 100;

function toast(msg){
  const t=document.getElementById('toast');
  t.textContent=msg; t.classList.add('on');
  clearTimeout(t._h); t._h=setTimeout(()=>t.classList.remove('on'),2200);
}

/* =========================================================
   Cart
   ========================================================= */
function addToCart(p,opt){
  const key = p.id+'|'+opt.storage+'|'+opt.color+'|'+opt.grade;
  const found = state.cart.find(i=>i.key===key);
  if(found) found.qty++;
  else state.cart.push({key,id:p.id,name:p.name,art:opt.shot||p.art,storage:opt.storage,color:opt.color,grade:opt.grade,price:gradePrice(storageBase(p,p.storage.indexOf(opt.storage)),opt.grade),qty:1});
  renderCart(); toast('Added to cart');
}
function cartTotal(){ return state.cart.reduce((s,i)=>s+i.price*i.qty,0); }
function cartQty(){ return state.cart.reduce((s,i)=>s+i.qty,0); }

function renderCart(){
  try{ localStorage.setItem('dv_cart', JSON.stringify(state.cart)); }catch(e){}
  document.getElementById('cartCount').textContent = cartQty();
  const body=document.getElementById('cartBody'), foot=document.getElementById('cartFoot');
  if(!state.cart.length){
    body.innerHTML=`<div class="empty"><p style="font-size:17px;color:var(--ink);font-weight:700;margin-bottom:6px">Nothing in here yet</p>
      <p style="margin:0 0 18px">Tested devices, covered 12 months, most shipping same day.</p>
      <a class="btn" href="#/shop" data-close>Shop devices</a></div>`;
    foot.innerHTML='';
    return;
  }
  const sub=cartTotal(), left=Math.max(0,FREE_SHIP-sub);
  body.innerHTML = `
    <div class="ship">${left>0?`Add ${money(left)} for free shipping`:'Free shipping unlocked'}
      <div class="bar"><i style="width:${Math.min(100,sub/FREE_SHIP*100)}%"></i></div></div>
    ${state.cart.map(i=>`
      <div class="line-item">
        <div class="mini">${art(i.art,i.name,42)}</div>
        <div style="flex:1;min-width:0">
          <h4>${i.name}</h4>
          <div class="meta">${optLine(i,GRADES[i.grade].label)}</div>
          <div class="qty">
            <button data-dec="${i.key}" aria-label="Decrease quantity">−</button>
            <span>${i.qty}</span>
            <button data-inc="${i.key}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <div style="text-align:right">
          <div style="font-weight:700">${money(i.price*i.qty)}</div>
          <button data-rm="${i.key}" style="color:var(--muted);font-size:13px;font-weight:700;margin-top:8px;text-decoration:underline">Remove</button>
        </div>
      </div>`).join('')}`;
  foot.innerHTML = `
    <div class="totals"><span>Subtotal</span><span>${money(sub)}<small>${left>0?'Shipping calculated at checkout':'Shipping free'}</small></span></div>
    <a class="btn wide" href="#/checkout" data-close>Checkout</a>
    <p style="text-align:center;color:var(--muted);font-weight:700;font-size:13px;margin:12px 0 0">Covered 12 months · 30 days to return · Free returns</p>`;
}

function openCart(o){
  document.getElementById('drawer').classList.toggle('on',o);
  document.getElementById('drawer').setAttribute('aria-hidden',String(!o));
  document.getElementById('overlay').classList.toggle('on',o);
  document.body.style.overflow = o?'hidden':'';
}

/* =========================================================
   View helpers
   ========================================================= */
function shotsFor(p){
  const base=p.colors[Math.min(sel.color,p.colors.length-1)][1];
  return [base, base+'_2', base+'_3'].filter(k=>IMG[k]);
}

const SWATCH = {
  'black':'#1D1D1F','space black':'#2B2B2E','black titanium':'#3A3A3C','midnight':'#1F2430','graphite':'#4A4B4F',
  'white':'#F2F2F4','silver':'#E3E4E8','white titanium':'#EDEDEA','starlight':'#EDE6DA','robot white':'#F4F4F6',
  'natural titanium':'#BFB8AD','desert titanium':'#C9AE92','cosmic orange':'#E07A3A',
  'blue':'#3E6A8A','blue titanium':'#3C4A62','deep blue':'#2C3E63','light blue':'#BCD4EA','ultramarine':'#6C7CE6',
  'teal':'#98CBC3','green':'#B6D2C1','pink':'#F1A9CF','violet':'#5E528F','deep purple':'#5B4A66','burgundy':'#6B2A36',
  'space grey':'#6A6B6E','red':'#B32135'
};
function dotsFor(p){
  if(p.colors.length<2) return '';
  return `<div class="dots2">${p.colors.slice(0,5).map(c=>`<i title="${c[0]}" style="background:${c[2]||SWATCH[c[0].toLowerCase()]||'#C7C7CC'}"></i>`).join('')}${p.colors.length>5?`<b>+${p.colors.length-5}</b>`:''}</div>`;
}

function tagFor(p){
  if(p.cat==='iphone'||p.cat==='android') return 'Unlocked';
  if(p.cat==='ipad') return p.specs.Connectivity||'Wi-Fi';
  return p.brand;
}
function pipFor(g){ return `<span class="pip ${GRADES[g].pip}"></span>`; }

function ico(name,size){
  const s=size||19;
  const paths={
    shield:'<path d="M12 3 4.5 6v6c0 4.4 3.1 8.1 7.5 9 4.4-.9 7.5-4.6 7.5-9V6z"/><path d="m8.8 12 2.2 2.2 4.2-4.4"/>',
    rotate:'<path d="M4 8h13l-3-3M20 16H7l3 3"/>',
    check:'<path d="m5 12.5 4.5 4.5L19 7.5"/>',
    truck:'<path d="M2.5 16V6.5h11V16M13.5 10h4l3 3.2V16M2.5 16h2M11.5 16h3.5"/><circle cx="6.5" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/>',
    lock:'<rect x="5" y="10" width="14" height="10" rx="2.5"/><path d="M8.5 10V7.5a3.5 3.5 0 0 1 7 0V10"/>',
    leaf:'<path d="M19 5c0 8-5 12-11 12H5c0-8 5-12 11-12z"/><path d="M5 19c3-6 7-8 10-9"/>',
    battery:'<rect x="3" y="7.5" width="15.5" height="9" rx="2.2"/><path d="M21 11v2M6.5 10.5v3M9.5 10.5v3M12.5 10.5v3"/>',
    scan:'<path d="M4 8V5.5A1.5 1.5 0 0 1 5.5 4H8M16 4h2.5A1.5 1.5 0 0 1 20 5.5V8M20 16v2.5a1.5 1.5 0 0 1-1.5 1.5H16M8 20H5.5A1.5 1.5 0 0 1 4 18.5V16M8 12h8"/>',
    parts:'<circle cx="12" cy="12" r="3"/><path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1"/>',
    erase:'<path d="M4 7h16M9 7V4.5h6V7M6.5 7l1 12.5h9l1-12.5"/>',
    phone:'<rect x="6.5" y="2.5" width="11" height="19" rx="2.6"/><path d="M10.5 18.5h3"/>',
    cable:'<path d="M9 3v4M15 3v4M7.5 7h9v3.5a4.5 4.5 0 0 1-9 0zM12 15v2.5a3.5 3.5 0 0 0 3.5 3.5H19"/>',
    box:'<path d="M3.5 7.5 12 3l8.5 4.5v9L12 21l-8.5-4.5z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/>',
    tag:'<path d="M3.5 12.2V4.5a1 1 0 0 1 1-1h7.7l8.3 8.3a1.4 1.4 0 0 1 0 2l-6.2 6.2a1.4 1.4 0 0 1-2 0z"/><circle cx="8" cy="8" r="1.4"/>',
    test:'<path d="M9 3h6M10 3v6l-5 9.5A1.7 1.7 0 0 0 6.5 21h11a1.7 1.7 0 0 0 1.5-2.5L14 9V3"/>'
  };
  return `<svg width="${s}" height="${s}" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">${paths[name]||''}</svg>`;
}


const LAUNCH_ONLY=['ip15pm','ip15pro','ip15plus','ip15','ip14pm','ip14p','ip14plus','ip14','ip13pm','ip13pro','ip13','ip13mini','ip12','ip12mini','ip11','ipxr','s25p','s25','s24p','s24','s23p','s23','ipadair'];   // no longer sold new by Apple: compare with launch price
const newWord = p => LAUNCH_ONLY.includes(p.id) ? 'at launch' : 'new';
function cardHTML(p){
  const sold = p.stock===0, pct = Math.round((p.msrp-p.price)/p.msrp*100);
  return `<a class="card" href="#/p/${p.id}">
    <div class="thumb">${art(p.art,p.name,100)}</div>
    <h3>${p.name}</h3>
    <div class="meta">${[isCapacity(p.storage[0])?p.storage[0]:null, GRADES.excellent.label, tagFor(p)].filter(Boolean).join(' · ')}</div>
    ${dotsFor(p)}
    <div class="cond">${pipFor('excellent')} Deviceli Certified</div>
    <div class="price">${money(p.price)}<span class="was">${money(p.msrp)} ${newWord(p)}</span></div>
    ${sold?`<span class="soldout">Sold out</span>`:`<span class="save">Save ${pct}% vs ${LAUNCH_ONLY.includes(p.id)?'launch price':'new'}</span>`}
  </a>`;
}


function tradeBanner(withShell){
  const inner = `<div class="trade">
    <svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 8h13l-3-3M20 16H7l3 3"/></svg>
    <div class="txt"><h3>Sell your old device</h3><p>A firm offer in 60 seconds. Free pickup in Ottawa–Gatineau, or a prepaid label anywhere in Canada.</p></div>
    <a class="btn" href="#/sell">See what it's worth</a>
  </div>`;
  return withShell===false ? inner : `<div class="shell">${inner}</div>`;
}

/* =========================================================
   Pages
   ========================================================= */
const COPY = {
'ip16pm':["The biggest iPhone Apple made before the 18 series, and the one that holds its value.",
  [["6.9-inch display","The largest Super Retina XDR at 120Hz."],
   ["A18 Pro chip","Apple Intelligence, and years of updates left."],
   ["48MP triple camera","5x telephoto and 4K120 video."]],
  "Device, USB-C cable and wall block."],
'ip16pro':["A Pro at a price the base model reached last year. Desert Titanium is the colour people ask for.",
  [["A18 Pro chip","Fast today, supported for years."],
   ["Titanium frame","Lighter than steel, tougher than glass."],
   ["Camera Control","A dedicated button for the camera."]],
  "Device, USB-C cable and wall block."],
'ip15pm':["The first Pro Max with 5x zoom and USB-C, now at half what it cost new.",
  [["5x telephoto","The longest zoom on any iPhone of its year."],
   ["A17 Pro chip","Handles every current app."],
   ["USB-C","One cable for the phone, the iPad and the Mac."]],
  "Device, USB-C cable and wall block."],
'ip15pro':["The cheapest way into titanium, USB-C and the Action button.",
  [["Titanium frame","Noticeably lighter in the hand."],
   ["A17 Pro chip","Console-grade games, smooth daily use."],
   ["Action button","Replace the mute switch with what you use."]],
  "Device, USB-C cable and wall block."],
'ip16plus':["The big screen and the long battery, without the Pro price.",
  [["6.7-inch display","Room for two apps, films and maps."],
   ["Longest battery","The best runtime of the 16 line."],
   ["A18 chip","Apple Intelligence ready."]],
  "Device, USB-C cable and wall block."],

'ip18pm':["The biggest screen and the longest battery Apple makes, one generation behind the counter price.",
  [["6.9-inch display","The largest Super Retina XDR, at 120Hz."],
   ["A20 Pro chip","Years of updates ahead of it."],
   ["48MP triple camera","5x telephoto, ProRAW, 4K120 video."]],
  "Device, USB-C cable and wall block."],
'ip18p':["The current Pro in the hand-friendly size, tested and warrantied like everything else we sell.",
  [["A20 Pro chip","Handles anything, including on-device AI."],
   ["Titanium frame","Light, and tougher than glass."],
   ["48MP triple camera","Telephoto, ProRAW, cinematic video."]],
  "Device, USB-C cable and wall block."],
's26u':["Samsung's flagship with the S Pen built in, at a price the new one will not reach for a long time.",
  [["200MP camera","Quad lenses, 5x optical zoom."],
   ["S Pen included","Notes, edits and precise selection."],
   ["6.9-inch AMOLED","120Hz, readable in full sun."]],
  "Device, S Pen, USB-C cable."],
"ip17p": ["The 17 Pro is the fastest iPhone we stock, and the one people keep the longest.", [["A19 Pro chip", "Handles anything you throw at it for years to come."], ["48MP triple camera", "5x telephoto, ProRAW, cinematic video."], ["Titanium frame", "Lighter than it looks, tougher than glass."]], "Device, USB-C cable and wall block."], "ip16": ["The iPhone 16 is the sweet spot: recent enough for every app, old enough to cost half of new.", [["A18 chip", "Apple Intelligence ready, fast for years."], ["48MP dual camera", "2x optical-quality zoom without a third lens."], ["Action button", "Remap it to the camera, the flashlight, whatever you use."]], "Device, USB-C cable and wall block."], "ip14p": ["Still the best value in a Pro: ProMotion, telephoto and Dynamic Island for the price of a mid-range new phone.", [["120Hz ProMotion", "Scrolling that makes a cheaper new phone feel slow."], ["48MP triple camera", "3x telephoto and the low-light sensor Pro models are known for."], ["Dynamic Island", "Live alerts and timers at the top of the screen."]], "Device, USB-C cable and wall block."], "ip13": ["Five years on, the iPhone 13 still gets iOS updates and still takes excellent photos. Our best seller.", [["A15 Bionic", "Runs every current app without a stutter."], ["All-day battery", "One of the longest-lasting iPhones of its generation."], ["Ceramic Shield", "Front glass tougher than most phones on sale today."]], "Device, Lightning cable and wall block."], "ip12": ["The cheapest way into a modern iPhone: 5G, OLED screen, Face ID, under C$350.", [["OLED display", "True blacks, not the LCD you get on new budget phones."], ["5G", "Full speed on every Canadian carrier."], ["A14 Bionic", "Still supported, still quick."]], "Device, Lightning cable and wall block."], "ipadair": ["An iPad Air with the M2 chip does everything the Pro does, for most people, at half the outlay.", [["Apple M2", "The same chip family as a MacBook Air."], ["11-inch Liquid Retina", "Laminated, anti-reflective, great for drawing."], ["Apple Pencil Pro ready", "Pairs and charges on the side magnetically."]], "Tablet, USB-C cable and wall block."], "mbp14": ["A 14-inch Pro is the machine that survives a whole career change. This one has years of work left.", [["M3 Pro, 18GB", "Video editing, Xcode, forty browser tabs. No fan noise."], ["Liquid Retina XDR", "1000 nits sustained, 120Hz, real HDR."], ["Ports that matter", "HDMI, SDXC, three Thunderbolt, MagSafe."]], "Laptop, MagSafe charger and USB-C power adapter."], "aw": ["Series 9 is the last generation before prices climbed. Wiped, reset, and fitted with a fresh band.", [["Always-On Retina", "Readable in direct sun, dims on your wrist."], ["ECG and blood oxygen", "The full health sensor set."], ["Double tap", "Answer a call with a pinch, one-handed."]], "Watch, new sport band and magnetic charging cable."], "ps5": ["A PS5 Slim with the disc drive, so you can buy games used too. Tested on a full game before it ships.", [["4K up to 120Hz", "Ray tracing and 3D audio on a modern TV."], ["1TB SSD", "Loading screens measured in seconds."], ["Disc drive", "Play and resell physical games."]], "Console, one DualSense controller, HDMI and power cables."], "ds5": ["A spare DualSense so the second player stops complaining.", [["Haptic feedback", "You feel surfaces and tension, not just rumble."], ["Adaptive triggers", "Resistance that changes with what you're doing."], ["PS5 and PC", "Works over Bluetooth on both."]], "Controller and USB-C cable."], "portal": ["Your PS5 on an 8-inch screen, anywhere in the house. The quiet answer to sharing the TV.", [["8-inch 1080p screen", "60fps streaming from your own PS5."], ["Full DualSense controls", "Haptics and adaptive triggers built in."], ["Up to 9 hours", "Long enough for any session."]], "Device and USB-C cable."], "xboxss": ["The cheapest way onto current-generation Xbox, and Game Pass makes the digital-only part a non-issue.", [["Up to 1440p 120Hz", "Smooth on a modern TV or monitor."], ["512GB SSD", "Near-instant resume between games."], ["Game Pass ready", "Hundreds of games on a monthly plan."]], "Console, one controller, HDMI and power cables."], "xboxpad": ["Works on Xbox, on Windows, and on your phone. The controller most PC players end up buying.", [["Textured grips", "Triggers and bumpers you don't slip off."], ["Share button", "Clip the last thirty seconds in one press."], ["Bluetooth", "Pairs with PC, iPhone and Android."]], "Controller only, batteries not included."], "ap3": ["Open, wear, done. AirPods with Spatial Audio for less than half of what new ones cost.", [["Spatial Audio", "Sound that stays put when you turn your head."], ["Sweat and water resistant", "Fine for the gym and the rain."], ["Up to 6 hours", "Thirty total with the case."]], "Earbuds, charging case and Lightning cable."]};

function addBizDays(d,n){ const x=new Date(d); while(n>0){ x.setDate(x.getDate()+1); const w=x.getDay(); if(w!==0&&w!==6) n--; } return x; }
function fmtDay(d){ return d.toLocaleDateString('en-CA',{weekday:'short',month:'short',day:'numeric'}); }
function delivery(){
  const now=new Date(), cutoff=new Date(now); cutoff.setHours(14,0,0,0);
  const w=now.getDay(), shipsToday = w!==0 && w!==6 && now<cutoff;
  const ship = shipsToday ? now : addBizDays(now,1);
  const a=addBizDays(ship,2), b=addBizDays(ship,4);
  let left='';
  if(shipsToday){ const m=Math.round((cutoff-now)/60000); left = m>=60 ? `${Math.floor(m/60)}h ${m%60}m` : `${m}m`; }
  return {range:`${fmtDay(a)} – ${fmtDay(b)}`, left, shipsToday};
}

const RANK = ['ip18pm','ip18p','ip17p','ip16pm','ip16pro','ip16plus','ip16','ip15pm','ip15pro','ip15plus','ip15','ip14pm','ip14p','ip14plus','ip14','ip13pm','ip13pro','ip13','ip13mini','ip12','ip12mini','ip11','ipxr',
              's26u','s25p','s25','s24p','s24','s23p','s23','ipadairm3','ipadmini7','ipad11','ipadair','mbp14','aw','ps5','portal','xboxss','ds5','xboxpad','ap3'];
P.sort((a,b)=>{
  const ca=CATS.findIndex(c=>c.id===a.cat), cb=CATS.findIndex(c=>c.id===b.cat);
  if(ca!==cb) return ca-cb;
  const ra=RANK.indexOf(a.id), rb=RANK.indexOf(b.id);
  return (ra<0?999:ra)-(rb<0?999:rb);
});

const ACCESSORIES = ['ds5','xboxpad','ap3'];

/* the entry price and the photo must describe the SAME device, or the banner misleads */
function cheapest(cat){
  const list = P.filter(p=>p.cat===cat && p.stock>0 && !ACCESSORIES.includes(p.id));
  return list.length ? list.reduce((a,b)=>b.price<a.price?b:a) : null;
}

const HERO_VIDEO = '';   // paste the URL of a short clip (MP4) here; the photo is used until then

const SLIDES = [
  {photo:'hero_lifestyle', title:()=>'Your trusted destination for refurbished tech.', sub:()=>'Fully tested and inspected. Backed by a 12-month warranty.',
   cta:'Shop certified', href:'#/shop', cta2:'Sell yours', href2:'#/sell', art:[['hero_lifestyle',0]]},
  {bg:'#E4EDFF', cat:'iphone', sub:()=>'Unlocked for every carrier. Battery at 80% or better, or we don\u2019t sell it.', cta:'Shop iPhone', href:'#/shop/iphone'},
  {dark:true,    cat:'ipad',   sub:()=>'Same screen, same chip, same apps. One price tag down.', cta:'Shop iPad', href:'#/shop/ipad'},
  {bg:'#EAF0FF', cat:'android', sub:()=>'S Pen included, tested like everything else.', cta:'Shop Samsung', href:'#/shop/android'},
  {bg:'#DCE8FF', cat:'watch',  sub:()=>'Wiped, reset and fitted with a new band. Looks new on the wrist.', cta:'Shop watches', href:'#/shop/watch'},
  {bg:'#EAF0FF', cat:'mac',    sub:()=>'We publish the battery health before you buy. No surprises on day one.', cta:'Shop MacBook', href:'#/shop/mac'},
  {bg:'#E4EDFF', cat:'gaming', sub:()=>'Every console runs a full game before it ships. Controller included.', cta:'Shop gaming', href:'#/shop/gaming'}
];

function slideHTML(sl){
  if(sl.photo){
    return `<div class="slide photo">
      <div class="sphoto">${HERO_VIDEO
        ? `<video src="${HERO_VIDEO}" poster="${IMG[sl.photo]}" autoplay muted loop playsinline preload="metadata" aria-label="Devices being tested"></video>`
        : `<img src="${IMG[sl.photo]}" alt="Person smiling at a refurbished phone" loading="eager">`}</div>
      <div class="stxt">
        <h2>${sl.title()}</h2>
        <p>${sl.sub()}</p>
        <div class="slideacts pacts">
          <a class="hbtn solid" href="${sl.href}">${sl.cta}<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg></a>
          <a class="hlink" href="${sl.href2}">${sl.cta2}</a>
        </div>
        <p class="hproof">Tested by hand · 12-month warranty · 30-day returns</p>
      </div>
    </div>`;
  }
  const p = sl.cat ? cheapest(sl.cat) : null;
  const title = p ? `${p.name} from ${money(p.price)}` : (typeof sl.title==='function'?sl.title():sl.title);
  const sub   = typeof sl.sub==='function'?sl.sub():sl.sub;
  const shot  = p ? p.art : sl.art[0][0];
  const size  = p ? 150 : sl.art[0][1];
  const href  = sl.href;
  const cta   = sl.cta;
  return `<div class="slide ${sl.dark?'dark':''}" style="${sl.bg?`background:${sl.bg}`:''}">
    <div class="stxt">
      <h2>${title}</h2>
      <p>${sub}</p>
      <div class="slideacts">
        <a class="btn" href="${href}">${cta}</a>
        ${sl.cta2?`<a class="btn line" href="${sl.href2}">${sl.cta2}</a>`:''}
      </div>
    </div>
    <div class="sart">${art(shot,title,size)}</div>
  </div>`;
}

function pageHome(){
  const popular = ['ip18pm','s26u','ip16pro','ipadair'].map(id=>P.find(p=>p.id===id)).filter(Boolean);
  return `<div class="homex">
  <section class="hhero">${slideHTML(SLIDES[0])}</section>

  <div class="trio">
    <div>${ico('shield',24)}<b>Covered 12 months</b></div>
    <div>${ico('check',24)}<b>Deviceli Certified</b></div>
    <div>${ico('rotate',24)}<b>30 days to return</b></div>
    <div>${ico('truck',24)}<b>Free over ${money(FREE_SHIP)}</b></div>
  </div>

  <section class="catsec"><div class="shell">
    <div class="sechead"><h2>Popular categories</h2></div>
    <div class="popcats">
      ${CATS.map(c=>{ const pic = c.id==='iphone' ? 'p18pro_blue' : c.art;
        return `<a class="pc" href="#/shop/${c.id}"><span class="pcimg">${art(pic,c.label,90)}</span><span class="pcname">${c.label}</span></a>`; }).join('')}
    </div>
  </div></section>

  <section class="tint"><div class="shell">
    <div class="sechead"><h2>In stock now</h2><a class="seclink" href="#/shop${state.fav?'/'+state.fav:''}">View all</a></div>
    <div class="favtabs" role="tablist">
      <button class="${!state.fav?'on':''}" data-fav="">Top picks</button>
      ${CATS.filter(c=>P.some(x=>x.cat===c.id&&x.stock>0)).map(c=>`<button class="${state.fav===c.id?'on':''}" data-fav="${c.id}">${c.label}</button>`).join('')}
    </div>
    <div class="grid">${(state.fav ? P.filter(x=>x.cat===state.fav&&x.stock>0).slice(0,4) : popular).map(cardHTML).join('')}</div>
  </div></section>

  <section class="proof"><div class="shell">
    <div class="proofband">
      <div><b data-count="30">30</b><span>checks by hand<br>on every device</span></div>
      <div><b data-count="80" data-suffix="%">80%</b><span>minimum<br>battery health</span></div>
      <div><b data-count="12">12</b><span>months of<br>warranty</span></div>
    </div>
    <p class="proofline">Tested and signed off by hand. <a class="more" href="#/care/grading">How we certify</a></p>
  </div></section>

  <section class="tint"><div class="shell">
    <div class="arrive">
      <div class="arrhead">
        <p class="arrkick">The unboxing</p>
        <h2>Arrives ready to use.</h2>
        <p class="arrsub">Every order ships in a Deviceli box, cleaned, reset and checked one last time. No bubble mailer, no third-party seller.</p>
      </div>
      <div class="arrimg"><img src="${BOXSHOT}" alt="A Deviceli box next to a refurbished iPhone" loading="lazy" width="640" height="800"></div>
      <div class="arrtxt">
        <p class="arrlabel">In the box</p>
        <div class="arrbox">
          <div>${ico('phone',22)}<b>Your device</b><span>Cleaned and reset</span></div>
          <div>${ico('cable',22)}<b>Charging cable</b><span>The right one for it</span></div>
          <div>${ico('box',22)}<b>Deviceli box</b><span>Packed with care</span></div>
        </div>
        <ul class="arrtrust">
          <li>${ico('check',16)}Hand-tested</li>
          <li>${ico('truck',16)}Tracked delivery</li>
          <li>${ico('shield',16)}12-month warranty</li>
        </ul>
        <a class="more" href="#/shop">Shop certified</a>
      </div>
    </div>
  </div></section>

  <section class="doors"><div class="shell">
    <div class="sechead"><h2>Buy, sell, or both</h2></div>
    <div class="doorgrid">
      <a class="door" href="#/shop">
        <span class="dpic">${art('p16_black','',64)}</span>
        <span class="dtext">
          <span class="dnum">Buy</span>
          <b>A certified device</b>
        </span>
        <span class="dend"><em>From ${money(Math.min(...P.filter(x=>x.stock>0 && !ACCESSORIES.includes(x.id)).map(x=>x.price)))}</em><i aria-hidden="true">›</i></span>
      </a>
      <a class="door" href="#/sell">
        <span class="dpic">${art('p13_blue','',64)}</span>
        <span class="dtext">
          <span class="dnum">Sell</span>
          <b>Your old device</b>
          <span class="dline">Offer in a minute, free pickup in Ottawa–Gatineau</span>
        </span>
        <span class="dend"><em>Up to ${money(Math.max(...Object.values(TRADE).flatMap(o=>o.list.map(m=>m[1]))))}</em><i aria-hidden="true">›</i></span>
      </a>
      <a class="door dark" href="#/company">
        <span class="dpic">${art('mbp14_black','',64)}</span>
        <span class="dtext">
          <span class="dnum">Business</span>
          <b>Fleets, schools, resellers</b>
        </span>
        <span class="dend"><em>Wholesale</em><i aria-hidden="true">›</i></span>
      </a>
    </div>
  </div></section></div>`;
}

function seriesOf(p){ const m=p.name.match(/^(iPhone \d+|iPhone X[RS]?|Galaxy S\d+|Galaxy Z \w+)/); return m?m[1]:null; }
function pageShop(cat,sort,series){
  const q = state.query.trim().toLowerCase();
  let list = P.filter(p => (!cat||p.cat===cat) && (!q || (p.name+' '+p.brand).toLowerCase().includes(q)));
  const allSeries = [...new Set(list.map(seriesOf).filter(Boolean))];
  if(series) list = list.filter(p=>seriesOf(p)===series);
  if(sort==='low') list=[...list].sort((a,b)=>a.price-b.price);
  if(sort==='high') list=[...list].sort((a,b)=>b.price-a.price);
  if(sort==='save') list=[...list].sort((a,b)=>(b.msrp-b.price)-(a.msrp-a.price));
  const title = cat ? (CATS.find(c=>c.id===cat)||{}).label : 'All devices';
  return `<div class="shell">
    <div class="crumbs"><a href="#/">Home</a> / ${title}</div>
    <div class="sechead" style="margin-top:12px"><h2>${title}</h2></div>
    <div class="shoptop">
      <a class="chip ${!cat?'on':''}" href="#/shop">All</a>
      ${CATS.map(c=>`<a class="chip ${cat===c.id?'on':''}" href="#/shop/${c.id}">${c.label}</a>`).join('')}
    </div>
    ${cat && allSeries.length>1 ? `<div class="shoptop models">
      <a class="chip ${!series?'on':''}" href="#/shop/${cat}">All models</a>
      ${allSeries.map(x=>`<a class="chip ${series===x?'on':''}" href="#/shop/${cat}?series=${encodeURIComponent(x)}">${x.replace('Galaxy ','')}</a>`).join('')}
    </div>` : ''}
    <div class="toolbar">
      <span class="count">${list.length} device${list.length===1?'':'s'}${q?` for “${state.query}”`:''}</span>
      <select class="sort" id="sortSel" aria-label="Sort products">
        <option value="">Featured</option>
        <option value="low" ${sort==='low'?'selected':''}>Price: low to high</option>
        <option value="high" ${sort==='high'?'selected':''}>Price: high to low</option>
        <option value="save" ${sort==='save'?'selected':''}>Biggest savings</option>
      </select>
    </div>
    ${list.length?`<div class="grid">${list.map(cardHTML).join('')}</div>`
      :`<div class="empty"><p style="color:var(--ink);font-size:16px;font-weight:700">No devices match that search.</p><p>Try a model name like “iPhone 13”, or pick a category above.</p></div>`}
    <div style="height:26px"></div>
    ${tradeBanner(false)}
    <div style="height:20px"></div>
  </div>`;
}

const sel = {storage:0,color:0,grade:'excellent',shot:0};
function pageProduct(id){
  const p = P.find(x=>x.id===id);
  if(!p) return `<div class="shell"><div class="empty">That product no longer exists. <a class="seclink" href="#/shop">Back to shop</a></div></div>`;
  sel.storage=Math.min(sel.storage,p.storage.length-1);
  const base = storageBase(p,sel.storage), newp = storageNew(p,sel.storage);
  const price = gradePrice(base,sel.grade);
  sel.color=Math.min(sel.color,p.colors.length-1); sel.storage=Math.min(sel.storage,p.storage.length-1);
  const shots = shotsFor(p);
  const slides = shots.map(k=>({k,ci:sel.color})).concat(p.colors.map((c,ci)=>({k:c[1],ci})).filter(x=>x.ci!==sel.color));
  const boxShot = p.cat==='iphone';           // the packaging photo shows a phone, so only iPhones get it
  return `<div class="shell">
    <div class="crumbs pxcrumbs"><a href="#/">Home</a> / <a href="#/shop/${p.cat}">${(CATS.find(c=>c.id===p.cat)||{}).label}</a> / ${p.name}</div>
    <div class="pdp">
      <div class="gcol">
        <div class="gtrack" id="gtrack">
          ${slides.map(sl=>`<div class="gslide" data-ci="${sl.ci}">${art(sl.k,p.name+', '+p.colors[sl.ci][0],300)}</div>`).join('')}
        </div>
        ${slides.length>1?`<div class="gdots" id="gdots">${slides.map((_,i)=>`<i class="${i===0?'on':''}"></i>`).join('')}</div>`:''}
      </div>
      <div class="px">
        <p class="pxcert"><span class="pip"></span>Deviceli Certified</p>
        <h1>${p.name}</h1>
        <p class="pxsub">${['iphone','android'].includes(p.cat)?'Unlocked, works with every carrier':p.brand} · 12-month warranty</p>

        <div class="pxprice"><b>${money(price)}</b><s>${money(newp)} ${newWord(p)}</s><em>Save ${money(newp-price)}</em></div>
        <p class="pxstock ${p.stock===0?'out':''}">${p.stock===0?'Sold out. Tell us and we’ll hold the next one.':p.stock<5?`Only ${p.stock} left at this price`:'In stock, ready to ship'}</p>

        ${p.storage.length>1?`<div class="pxlab"><b>Storage</b></div>
        <div class="pxopts n${Math.min(p.storage.length,4)}">${p.storage.map((s,i)=>`<button class="${i===sel.storage?'on':''}" data-storage="${i}"><b>${s}</b><small>${money(gradePrice(storageBase(p,i),sel.grade))}</small></button>`).join('')}</div>`:''}

        <div class="pxlab"><b>Colour</b><span id="colName">${p.colors[sel.color][0]}</span></div>
        <div class="pxsw" ${p.colors.length<2?'hidden':''}>${p.colors.map((c,i)=>`<button class="swatch ${i===sel.color?'on':''}" data-color="${i}" aria-label="${c[0]}">${art(c[1],c[0],36)}</button>`).join('')}</div>

        <div class="pxlab"><b>Condition</b><a class="pxhow" href="#/care/grading">How grading works</a></div>
        <div class="pxopts n3 pxgr">${Object.entries(GRADES).map(([k,g])=>`<button class="${sel.grade===k?'on':''}" data-grade="${k}"><b><span class="pip ${g.pip}"></span>${g.label}</b><small>${money(gradePrice(base,k))}</small></button>`).join('')}</div>
        <p class="pxnote">${GRADES[sel.grade].note} Every grade is 100% functional, with a battery at 80% or better.</p>

        <button class="btn wide pxbuy" id="addBtn" ${p.stock===0?'disabled':''}>${p.stock===0?'Out of stock':'Add to cart'}</button>
        ${p.stock>0?(()=>{ const d=delivery(); return `<p class="pxeta">${ico('truck',17)}<span>Arrives <b>${d.range}</b>. ${price>=FREE_SHIP?'Free tracked delivery.':'Tracked delivery, free over '+money(FREE_SHIP)+'.'}</span></p>`; })():''}

        <div class="pxperks">
          <div>${ico('shield',20)}<b>12-month warranty</b><span>Parts and labour</span></div>
          <div>${ico('rotate',20)}<b>30-day returns</b><span>Free, full refund</span></div>
          ${['ps5','xboxss','xboxpad'].includes(p.id)?`<div>${ico('check',20)}<b>30-point check</b><span>Tested by hand</span></div>`:`<div>${ico('battery',20)}<b>Battery 80%+</b><span>Measured by hand</span></div>`}
          ${['iphone','android'].includes(p.cat)?`<div>${ico('lock',20)}<b>Unlocked</b><span>Any Canadian carrier</span></div>`:`<div>${ico('truck',20)}<b>Tracked delivery</b><span>${price>=FREE_SHIP?'Free, across Canada':'Free over '+money(FREE_SHIP)}</span></div>`}
        </div>

        <div class="pxacc">
          ${p.blurb||p.high?`<details open><summary>About this ${p.name}</summary><div>
            ${p.blurb?`<p>${p.blurb}</p>`:''}
            ${p.high?`<ul class="pxhigh">${p.high.map(h=>`<li><b>${h[0]}</b><span>${h[1]}</span></li>`).join('')}</ul>`:''}
          </div></details>`:''}
          <details><summary>In the box</summary><div>
            ${boxShot?`<div class="boxscene"><img src="${BOXSHOT}" alt="What ships with the ${p.name}" loading="lazy"></div>`:''}
            <p>${p.box?p.box+'. ':''}Cleaned, wiped and reset before it ships.</p>
          </div></details>
          <details><summary>Specifications</summary><div>
            <dl class="pxspecs">${Object.entries(p.specs).map(([k,v])=>`<div><dt>${k}</dt><dd>${v}</dd></div>`).join('')}<div><dt>Warranty</dt><dd>12 months</dd></div><div><dt>Returns</dt><dd>30 days, free</dd></div></dl>
          </div></details>
          <details><summary>Delivery and returns</summary><div>
            <p>Orders placed before 2pm on a business day ship the same day, tracked, anywhere in Canada. Delivery is free over ${money(FREE_SHIP)}.</p>
            <p>Changed your mind? Send it back within 30 days. We pay the return shipping and refund every dollar. <a class="seclink" href="#/care/returns">Returns</a></p>
          </div></details>
        </div>
      </div>
    </div>
    ${p.stock>0?`<div class="buybar" id="buybar">
      <div><span>${p.name} · ${[isCapacity(p.storage[sel.storage])?p.storage[sel.storage]:null,GRADES[sel.grade].label].filter(Boolean).join(' · ')}</span><b>${money(price)}</b></div>
      <button class="btn" data-buybar>Add to cart</button>
    </div>`:''}
    <section><div class="sechead"><h2>You might also like</h2></div>
      <div class="grid">${P.filter(x=>x.cat===p.cat&&x.id!==p.id).slice(0,4).map(cardHTML).join('')}</div>
    </section>
  </div>`;
}

/* ---- sell flow ---- */
const sell = {step:0,cat:null,model:null,find:'',contract:null,carrier:null,storage:null,batt:null,grade:null,email:'',phone:'',name:'',contact:'',handoff:'pickup',slot:null,conn:null,ctrl:null,pay:'etransfer',basket:[],emailErr:'',help:false};

const STEP_LABELS = ['Category','Item','Details','Condition','Your offer','Next steps'];

const CARRIERS = [
  ['Telus',false],['Rogers',false],['Fido',false],['Koodo',false],
  ['Bell',true],['Freedom Mobile',true],['Virgin Plus',true]
];
const blockedCarrier = () => (CARRIERS.find(c=>c[0]===sell.carrier)||[,false])[1];

const HAS_BATTERY = ['iphone','android','ipad','mac','watch'];

const GRADES_SELL = [
  {k:'flawless', t:'Flawless', m:1,    d:'Looks like new. No visible scratches, no cracks, no dents.'},
  {k:'good',     t:'Good',     m:.92,  d:'Light wear you cannot see from arm\u2019s length. No cracks, no dents, screen perfect.'},
  {k:'used',     t:'Used',     m:.78,  d:'Visible scratches or dents, but the glass is intact and everything works.'},
  {k:'broken',   t:'Broken',   m:.42,  d:'Cracked glass, a fault, or it will not turn on. We still buy it.'}
];


/* =========================================================
   Buyback: the real configurations of each model.
   The price in TRADE is the value at the model's smallest configuration;
   each step up adds value. A model with one configuration skips the question.
   ========================================================= */
const CAP_STEP = [1, 1.07, 1.15, 1.22, 1.30];
const MODEL_CAPS = {
  /* iPhone */
  'iPhone 18 Pro Max':['256GB','512GB','1TB','2TB'], 'iPhone 18 Pro':['256GB','512GB','1TB'],
  'iPhone 17 Pro Max':['256GB','512GB','1TB','2TB'], 'iPhone 17 Pro':['256GB','512GB','1TB'], 'iPhone 17':['256GB','512GB'],
  'iPhone 16 Pro Max':['256GB','512GB','1TB'], 'iPhone 16 Pro':['128GB','256GB','512GB','1TB'],
  'iPhone 16 Plus':['128GB','256GB','512GB'], 'iPhone 16':['128GB','256GB','512GB'],
  'iPhone 15 Pro Max':['256GB','512GB','1TB'], 'iPhone 15 Pro':['128GB','256GB','512GB','1TB'], 'iPhone 15':['128GB','256GB','512GB'],
  'iPhone 14 Pro':['128GB','256GB','512GB','1TB'], 'iPhone 14':['128GB','256GB','512GB'],
  'iPhone 13':['128GB','256GB','512GB'], 'iPhone 12':['64GB','128GB','256GB'], 'iPhone 11':['64GB','128GB','256GB'],
  'iPhone SE (3rd Gen)':['64GB','128GB','256GB'],
  /* Android */
  'Galaxy S26 Ultra':['256GB','512GB','1TB'], 'Galaxy S25 Ultra':['256GB','512GB','1TB'], 'Galaxy S24 Ultra':['256GB','512GB','1TB'],
  'Galaxy S24':['128GB','256GB'], 'Galaxy S23':['128GB','256GB'], 'Galaxy Z Flip6':['256GB','512GB'], 'Galaxy Z Fold6':['256GB','512GB','1TB'],
  'Galaxy A55':['128GB','256GB'], 'Pixel 9 Pro':['128GB','256GB','512GB','1TB'], 'Pixel 9':['128GB','256GB'], 'Pixel 8':['128GB','256GB'],
  'OnePlus 12':['256GB','512GB'],
  /* iPad */
  'iPad Pro 13" (M4)':['256GB','512GB','1TB','2TB'], 'iPad Pro 11" (M4)':['256GB','512GB','1TB','2TB'],
  'iPad Air (M2)':['128GB','256GB','512GB','1TB'], 'iPad Air (5th Gen)':['64GB','256GB'], 'iPad (10th Gen)':['64GB','256GB'],
  'iPad (9th Gen)':['64GB','256GB'], 'iPad mini (6th Gen)':['64GB','256GB'],
  /* Mac: memory / storage */
  'MacBook Pro 16" M3 Max':['36GB / 1TB','48GB / 1TB','64GB / 2TB','128GB / 2TB'],
  'MacBook Pro 14" M3':['8GB / 512GB','8GB / 1TB','16GB / 1TB','24GB / 1TB'],
  'MacBook Air 15" M3':['8GB / 256GB','8GB / 512GB','16GB / 512GB','24GB / 1TB'],
  'MacBook Air 13" M3':['8GB / 256GB','8GB / 512GB','16GB / 512GB','24GB / 1TB'],
  'MacBook Air M2':['8GB / 256GB','8GB / 512GB','16GB / 512GB','24GB / 1TB'],
  'MacBook Air M1':['8GB / 256GB','8GB / 512GB','16GB / 512GB','16GB / 1TB'],
  'Mac mini (M2)':['8GB / 256GB','8GB / 512GB','16GB / 512GB','24GB / 1TB'],
  'iMac 24" (M1)':['8GB / 256GB','8GB / 512GB','16GB / 512GB','16GB / 1TB'],
  /* Watch: case size and connectivity */
  'Apple Watch Ultra 2':[['49mm, GPS + Cellular',1]],
  'Apple Watch Series 10':[['42mm, GPS',1],['46mm, GPS',1.05],['42mm, GPS + Cellular',1.1],['46mm, GPS + Cellular',1.15]],
  'Apple Watch Series 9':[['41mm, GPS',1],['45mm, GPS',1.05],['41mm, GPS + Cellular',1.1],['45mm, GPS + Cellular',1.15]],
  'Apple Watch Series 8':[['41mm, GPS',1],['45mm, GPS',1.05],['41mm, GPS + Cellular',1.1],['45mm, GPS + Cellular',1.15]],
  'Apple Watch SE (2nd Gen)':[['40mm, GPS',1],['44mm, GPS',1.05],['40mm, GPS + Cellular',1.1],['44mm, GPS + Cellular',1.15]],
  'Galaxy Watch7':[['40mm, Bluetooth',1],['44mm, Bluetooth',1.05],['40mm, LTE',1.1],['44mm, LTE',1.15]],
  'Pixel Watch 3':[['41mm, Wi-Fi',1],['45mm, Wi-Fi',1.06],['41mm, LTE',1.1],['45mm, LTE',1.16]],
  /* Gaming: editions that change the value */
  'PlayStation 5 Pro':[['2TB',1]],
  'PlayStation 5 Slim':[['Disc edition, 1TB',1],['Digital edition, 1TB',.88]],
  'Xbox Series X':[['1TB, disc',1],['2TB Galaxy Black',1.12],['1TB Digital, white',.9]],
  'Xbox Series S':[['512GB',1],['1TB',1.1]],
  'Nintendo Switch 2':[['256GB',1]], 'Nintendo Switch OLED':[['64GB',1]]
};
const CAP_TITLE = {iphone:'Storage', android:'Storage', ipad:'Storage', mac:'Memory and storage', watch:'Case size and connectivity', gaming:'Edition', audio:'Version'};
function capsFor(model){
  const raw = MODEL_CAPS[model];
  if(!raw) return [['Standard',1]];
  return raw.map((c,i)=>Array.isArray(c)?c:[c, CAP_STEP[Math.min(i,CAP_STEP.length-1)]]);
}
function upTo(model, base){ const c=capsFor(model); return Math.round(base*Math.max(...c.map(x=>x[1]))/5)*5; }
const ART_ALIAS = {'Xbox controller':'Xbox Wireless Controller'};
function modelArt(model, cat){
  const name=(ART_ALIAS[model]||model).toLowerCase();
  const p=P.find(x=>x.name.toLowerCase()===name);
  return p ? p.art : (TRADE[cat]||{}).art;
}

function capList(){ return capsFor(sell.model); }
function modelBase(){ const m=((TRADE[sell.cat]||{}).list||[]).find(x=>x[0]===sell.model); return m?m[1]:0; }
const BATT = [
  {k:'90', t:'90% or more',  m:1},
  {k:'85', t:'85 to 89%',    m:.97},
  {k:'80', t:'80 to 84%',    m:.93},
  {k:'79', t:'Below 80%',    m:.87},
  {k:'unk',t:"I don't know", m:.93}
];
function battInfo(){ return BATT.find(x=>x.k===sell.batt)||null; }
function batteryMult(){
  if(!HAS_BATTERY.includes(sell.cat)) return 1;
  const b=battInfo(); return b?b.m:1;
}
function battLabel(){ const b=battInfo(); return b ? (b.k==='unk'?'Battery to be checked':'Battery '+b.t.charAt(0).toLowerCase()+b.t.slice(1)) : null; }
const CONN_CATS=['ipad'];
function ctrlMult(){ return sell.cat==='gaming' && sell.ctrl==='no' ? 0.9 : 1; }
function connMult(){ return CONN_CATS.includes(sell.cat) && sell.conn==='cell' ? 1.06 : 1; }
function gradePriceSell(g){
  let v = modelBase();
  const cap = capList()[sell.storage]; if(cap) v*=cap[1];
  v *= connMult();
  v *= ctrlMult();
  v *= batteryMult();
  v *= g.m;
  return Math.max(5, Math.round(v/5)*5);
}
function maxPrice(){
  if(sell.storage==null) return upTo(sell.model, modelBase());
  let v = modelBase();
  const cap = capList()[sell.storage]; if(cap) v*=cap[1];
  v *= connMult();
  return Math.round(v/5)*5;
}
function offerValue(){
  const g = GRADES_SELL.find(x=>x.k===sell.grade) || GRADES_SELL[0];
  return gradePriceSell(g);
}

function itemBar(){
  const cap = capList()[sell.storage];
  const bits = [cap?cap[0]:null, HAS_BATTERY.includes(sell.cat)?battLabel():null, sell.contract==='yes'?'Under contract':null].filter(Boolean);
  return `<div class="itembar">
    ${art(modelArt(sell.model,sell.cat),sell.model,44)}
    <div><b>${sell.model}</b><span>${bits.join(' · ')||'Tell us the details'}</span>
      <button class="changeitem" data-sellstep="1">Change item</button></div>
  </div>`;
}
function stepBar(i){
  return `<div class="stephead"><span>Step ${i} of 5</span><b>${STEP_LABELS[i]}</b></div>
    <div class="steps">${STEP_LABELS.slice(1).map((_,n)=>`<span class="step ${n<i?'on':''}"></span>`).join('')}</div>`;
}

function pageSell(){
  let inner='';

  if(sell.step===0){
    const q=(sell.find||'').trim().toLowerCase();
    const all = Object.entries(TRADE).flatMap(([c,o])=>o.list.map(m=>[c,m[0],m[1]]));
    const hits = q ? all.filter(x=>x[1].toLowerCase().includes(q)).slice(0,8) : [];
    const popular = [...all].map(([c,m,v])=>[c,m,upTo(m,v)]).sort((a,b)=>b[2]-a[2]).slice(0,8);
    inner = `
    <div class="sellsearch">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg>
      <input id="modelFind" placeholder="Search your model" value="${sell.find||''}" aria-label="Search every model we buy">
    </div>
    ${q?(hits.length?`<div class="catlist">${hits.map(([c,m,v])=>`<button class="catrow" data-sellquick="${c}|${m}">${art(modelArt(m,c),'',44)}<span>${m}</span><b>Up to ${money(upTo(m,v))}</b></button>`).join('')}</div>`
      :`<p class="hint" style="text-align:center">No match for “${sell.find}”. <a class="seclink" href="#/care/contact">Send us the model</a></p>`):''}

    <h2 class="selltitle">What are you selling?</h2>
    <div class="catlist big">
      ${Object.entries(TRADE).map(([k,o])=>`<button class="catrow" data-sellcat="${k}">${art(o.art,o.label,56)}<span>${o.label}</span><i aria-hidden="true">›</i></button>`).join('')}
    </div>
    <p class="notlisted">Not listed? <a class="seclink" href="#/care/contact">Request a quote</a></p>

    <h2 class="selltitle" style="margin-top:34px">Top payouts</h2>
    <div class="payrow" aria-label="Top payouts">
      ${popular.map(([c,m,v])=>`<button class="paypill" data-sellquick="${c}|${m}"><span>${m}</span><b>${money(v)}</b></button>`).join('')}
    </div>

    <div class="how3">
      <div><b>1</b><span><strong>Get your price</strong>A few questions, about a minute.</span></div>
      <div><b>2</b><span><strong>Hand it over</strong>Free pickup, a meetup, or a prepaid label.</span></div>
      <div><b>3</b><span><strong>Get paid</strong>Cash or e-Transfer, the same day it passes inspection.</span></div>
    </div>

    <div class="sfaq slim">
      <details><summary>Is my offer guaranteed?</summary><p>Yes, if the device matches what you described. If not, you get a revised offer with the reason, and if you decline we send it back free.</p></details>
      <details><summary>Do you buy broken devices?</summary><p>Yes. Cracked screens, weak batteries, devices that will not turn on. Pick Broken and you still get a price.</p></details>
      <details><summary>What do I do before handing it over?</summary><p>Sign out of iCloud or Google and erase it. <a class="seclink" href="#/care/wipe">Here is how</a>.</p></details>
      <details><summary>Are there any fees?</summary><p>No. You receive the amount you accept.</p></details>
    </div>`;
  } else if(sell.step===1){
    const q=(sell.find||'').toLowerCase();
    const list=TRADE[sell.cat].list.filter(m=>!q||m[0].toLowerCase().includes(q));
    inner = `<a class="backlink" data-sellstep="0">‹ Back</a>${stepBar(1)}
      <div class="qs"><h2>${({iphone:'Which iPhone?',android:'Which Android phone?',ipad:'Which iPad?',mac:'Which Mac?',watch:'Which smartwatch?',audio:'Which AirPods or headphones?',gaming:'Which console or controller?'})[sell.cat]}</h2>
      <p class="hint">Best-case prices. Your answers set the exact offer.</p>
      <input class="field" id="modelFind" placeholder="Type a model name" value="${sell.find||''}" aria-label="Find your model">
      ${list.length?list.map(m=>`<button class="pick" data-sellmodel="${m[0]}"><span>${m[0]}<small>${capsFor(m[0]).length>1?capsFor(m[0])[0][0]+' to '+capsFor(m[0])[capsFor(m[0]).length-1][0]+' · ':''}Up to ${money(upTo(m[0],m[1]))}</small></span><span class="arrow">›</span></button>`).join('')
        :`<p class="hint">Nothing matches that. <a class="seclink" href="#/care/contact">Tell us the model</a> and we price it by hand.</p>`}
      </div>`;

  } else if(sell.step===2){
    const needsCarrier = sell.contract==='yes' && ['iphone','android'].includes(sell.cat);
    const needsConn = CONN_CATS.includes(sell.cat);
    const needsCtrl = sell.cat==='gaming' && /PlayStation 5|PS5|Xbox Series|Switch/i.test(sell.model||'');
    const needsBatt = HAS_BATTERY.includes(sell.cat);
    const caps = capList();
    if(caps.length===1) sell.storage = 0;
    const ready = sell.contract!=null && sell.storage!=null && (!needsBatt || sell.batt) && (!needsConn || sell.conn) && (!needsCtrl || sell.ctrl) && !(needsCarrier && (!sell.carrier || blockedCarrier()));
    inner = `<a class="backlink" data-sellstep="1">‹ Back</a>${stepBar(2)}${itemBar()}
      <div class="uptop"><span>Up to</span><b>${money(maxPrice())}</b></div>

      <section class="card2">
        <h3>Is it under contract or still financed?</h3>
        <div class="twocol">
          <button class="opt big ${sell.contract==='yes'?'on':''}" data-sellcontract="yes">Yes</button>
          <button class="opt big ${sell.contract==='no'?'on':''}" data-sellcontract="no">No</button>
        </div>
        ${needsCarrier?`
          <h3 class="sub">Which carrier is it financed with?</h3>
          <div class="twocol">
            ${CARRIERS.map(c=>`<button class="opt big carrier ${sell.carrier===c[0]?'on':''} ${c[1]?'no':''}" data-sellcarrier="${c[0]}">${c[0]}${c[1]?'<small>Not accepted</small>':''}</button>`).join('')}
          </div>
          ${sell.carrier?(blockedCarrier()?`
            <div class="blocked">
              <b>We cannot take this one</b>
              <p>A device still financed with ${sell.carrier} stays tied to the account until the balance is settled, so we are not able to buy it. Clear the balance and the offer comes back.</p>
              <div class="blockbtns">
                <button class="btn sm line" data-sellstep="1">Change item</button>
                <button class="btn sm" data-sellcarrier="">Pick another carrier</button>
              </div>
            </div>`:`
            <p class="note">Fine with us. The balance still has to be cleared with ${sell.carrier} before we can pay you. We will help you sort it out.</p>`):''}
        `:''}
      </section>

      ${caps.length>1?`<section class="card2">
        <h3>${CAP_TITLE[sell.cat]||'Configuration'}</h3>
        <div class="twocol">
          ${caps.map((c,i)=>`<button class="opt big ${sell.storage===i?'on':''}" data-sellstorage="${i}">${c[0]}</button>`).join('')}
        </div>
        ${sell.cat==='mac'?`<p class="hint" style="margin:10px 0 0">Apple menu › About This Mac shows the memory and the storage.</p>`:''}
        ${['iphone','android','ipad'].includes(sell.cat)?`<p class="hint" style="margin:10px 0 0">Settings › General › About shows the capacity.</p>`:''}
      </section>`:''}

      ${needsCtrl?`<section class="card2">
        <h3>${/Switch/.test(sell.model)?'Are both Joy-Con included?':'Is a controller included?'}</h3>
        <div class="twocol">
          <button class="opt big ${sell.ctrl==='yes'?'on':''}" data-sellctrl="yes">Yes</button>
          <button class="opt big ${sell.ctrl==='no'?'on':''}" data-sellctrl="no">No</button>
        </div>
      </section>`:''}

      ${needsConn?`<section class="card2">
        <h3>Wi-Fi or Wi-Fi + Cellular?</h3>
        <div class="twocol">
          <button class="opt big ${sell.conn==='wifi'?'on':''}" data-sellconn="wifi">Wi-Fi</button>
          <button class="opt big ${sell.conn==='cell'?'on':''}" data-sellconn="cell">Wi-Fi + Cellular</button>
        </div>
        <p class="hint" style="margin:10px 0 0">Cellular models have a SIM tray on the side.</p>
      </section>`:''}

      ${HAS_BATTERY.includes(sell.cat)?`
      <section class="card2">
        <h3>Battery health <button class="helplink" data-sellhelp>Where do I find it?</button></h3>
        ${sell.help?`<div class="helpbox"><b>Where to look</b><p>iPhone: Settings › Battery › Battery Health › Maximum Capacity.<br>Mac: hold Option, click the Apple menu › System Information › Power.<br>Android: Settings › Battery, or dial *#*#4636#*#*.</p></div>`:''}
        <div class="battgrid">
          ${BATT.map(x=>`<button class="opt big ${sell.batt===x.k?'on':''}" data-sellbatt="${x.k}">${x.t}</button>`).join('')}
        </div>
        ${sell.batt==='unk'?`<p class="hint" style="margin:10px 0 0">No problem. We check it at inspection, and if it is better than expected, you get more.</p>`:''}
      </section>`:''}

      <div style="height:78px"></div>
      <div class="stickybar">
        <div><span>Estimate</span><b>${money(gradePriceSell(GRADES_SELL[0]))}</b></div>
        <button class="btn" data-sellstep="3" ${ready?'':'disabled'}>Continue</button>
      </div>`;

  } else if(sell.step===3){
    inner = `<a class="backlink" data-sellstep="2">‹ Back</a>${stepBar(3)}${itemBar()}
      <div class="qs"><h2>Select the condition</h2>
      <p class="hint">Pick the one that matches. Accurate answers mean the price does not move at inspection.</p></div>
      <div class="gradesell">
        ${GRADES_SELL.map(g=>`<button class="gsell ${sell.grade===g.k?'on':''}" data-sellgrade="${g.k}">
          <span class="radio"></span>
          <span class="gtxt"><b>${g.t}</b><small>${g.d}</small></span>
          <span class="gprice">${money(gradePriceSell(g))}</span>
        </button>`).join('')}
      </div>
      <div style="height:78px"></div>
      <div class="stickybar">
        <div><span>${sell.grade?'Your offer':'Select a condition'}</span><b>${sell.grade?money(offerValue()):'—'}</b></div>
        <button class="btn" data-sellstep="4" ${sell.grade?'':'disabled'}>See my offer</button>
      </div>`;

  } else if(sell.step===4){
    const v = offerValue();
    const cap = capList()[sell.storage];
    const g = GRADES_SELL.find(x=>x.k===sell.grade);
    const ho = sell.handoff||'pickup';
    const basket = sell.basket||[];
    const total = v + basket.reduce((a,b)=>a+b.value,0);
    inner = `<a class="backlink" data-sellstep="3">‹ Back</a>${stepBar(4)}
      <div class="offercard">
        <div class="ohero">${art(modelArt(sell.model,sell.cat),sell.model,70)}
          <div><b>${sell.model}</b><span>${[cap?cap[0]:null,CONN_CATS.includes(sell.cat)?(sell.conn==='cell'?'Wi-Fi + Cellular':'Wi-Fi'):null,g.t,HAS_BATTERY.includes(sell.cat)?battLabel():null].filter(Boolean).join(' · ')}</span></div>
        </div>
        <p class="olabel">${basket.length?'This device':'Your offer'}</p>
        <div class="oamt">${money(v)}<small>CAD</small></div>
        ${basket.length?`<div class="basket">
          ${basket.map((b,i)=>`<div><span>${b.model}<small>${b.spec}</small></span><b>${money(b.value)}</b><button data-sellrm="${i}" aria-label="Remove">×</button></div>`).join('')}
          <div class="btot"><span>Combined offer, ${basket.length+1} devices</span><b>${money(total)}</b></div>
        </div>`:''}
        <button class="addmore" data-selladd>+ Add another device</button>
        <p class="opaid">${ho==='ship'?'Paid by Interac e-Transfer the day it passes inspection, within two business days of arrival.':'Tested in front of you and paid on the spot, in cash or by Interac e-Transfer.'}</p>

        <p class="olabel" style="margin-top:18px">How do you want to hand it over?</p>
        <div class="handoff three">
          <button class="ho ${ho==='pickup'?'on':''}" data-sellhandoff="pickup"><b>Free pickup</b><span>We come to you in Ottawa–Gatineau.</span></button>
          <button class="ho ${ho==='meet'?'on':''}" data-sellhandoff="meet"><b>Meetup</b><span>An agreed public place nearby.</span></button>
          <button class="ho ${ho==='ship'?'on':''}" data-sellhandoff="ship"><b>Free mail-in</b><span>Prepaid tracked label, anywhere in Canada.</span></button>
        </div>
        ${ho!=='ship'?`<div class="seg" role="group" aria-label="Paid by">
          <button class="${(sell.pay||'etransfer')==='etransfer'?'on':''}" data-sellpay="etransfer">e-Transfer</button>
          <button class="${sell.pay==='cash'?'on':''}" data-sellpay="cash">Cash</button>
        </div>`:''}

        <input class="field" id="sellName" autocomplete="name" placeholder="Your name" value="${sell.name||''}" aria-label="Your name">
        <input class="field" id="sellContact" autocomplete="email" placeholder="Email or phone number" value="${sell.contact||''}" aria-label="Email or phone number">
        ${sell.emailErr?`<p class="err">${sell.emailErr}</p>`:''}
        <button class="btn wide" data-selllock>${ho==='pickup'?'Book my free pickup':ho==='meet'?'Arrange a meetup':'Get my free label'} · ${money(total)}</button>
        <p class="ofine">By continuing, you confirm you own the device. No obligation to sell.</p>
        ${v<=25?`<p class="lowoffer">This one is worth very little. If you prefer, we can take it for recycling on any pickup, free.</p>`:''}
        <p class="olock">We honour ${money(total)} for 14 days, even if prices drop.</p>
      </div>

      <details class="pricedet"><summary>How we priced it</summary>
      <div class="openbook">
        <h3>Where the price comes from</h3>
        <div class="obrow"><span>What we expect to resell it for, once tested and warrantied</span><b>${money(Math.round(v/0.66/5)*5)}</b></div>
        <div class="obrow"><span>Testing, parts, 12-month warranty, shipping and returns</span><b>−${money(Math.round(v/0.66/5)*5 - v)}</b></div>
        <div class="obrow tot"><span>Your offer</span><b>${money(v)}</b></div>
        <p class="obnote">Typical figures for this category. If it needs less work than we expect, we pay you more at inspection.</p>
      </div>

      <h3 class="dhead">Your answers</h3>
      <ul class="qlines">
        <li><span>${sell.model}</span><b>${money(modelBase())}</b></li>
        ${cap&&capList().length>1?`<li><span>${cap[0]}</span><b>${cap[1]!==1?(cap[1]>1?'+':'−')+Math.round(Math.abs(1-cap[1])*100)+'%':'no change'}</b></li>`:''}
        ${HAS_BATTERY.includes(sell.cat)&&sell.batt?`<li><span>${battLabel()}</span><b>Included</b></li>`:''}
        <li><span>${g.t} condition</span><b>${g.m===1?'no change':'−'+Math.round((1-g.m)*100)+'%'}</b></li>
        ${sell.cat==='gaming'&&sell.ctrl?`<li><span>${sell.ctrl==='yes'?'Controller included':'No controller'}</span><b>Included</b></li>`:''}
        ${CONN_CATS.includes(sell.cat)?`<li><span>${sell.conn==='cell'?'Wi-Fi + Cellular':'Wi-Fi'}</span><b>Included</b></li>`:''}
        <li class="tot"><span>Total</span><b>${money(v)}</b></li>
      </ul>
      </details>
      <button class="backlink" style="margin-top:16px" data-sellreset>Start over</button>`;

  } else {
    const v = offerValue();
    const pick = (sell.handoff||'pickup')!=='ship';
    const meet = sell.handoff==='meet';
    const total = v + (sell.basket||[]).reduce((a,b)=>a+b.value,0);
    const slots=['Today 5–8pm','Tomorrow 9am–12pm','Tomorrow 1–5pm','Saturday 10am–4pm'];
    inner = `${stepBar(5)}
      <div class="qs"><h2>${pick?'Pick a time':'Your label is on its way'}</h2>
        <p class="hint">${money(total)} for ${(sell.basket||[]).length?((sell.basket.length+1)+' devices'):'your '+sell.model}, held 14 days. ${/@/.test(sell.contact||'')?'Confirmation sent to '+sell.contact:'We will text '+(sell.contact||'you')+' to confirm'}.</p></div>
      ${pick?`
      <div class="zone">
        <h3>${meet?'When suits you?':'When should we come by?'}</h3>
        <div class="slots">${slots.map(x=>`<button class="slot ${sell.slot===x?'on':''}" data-sellslot="${x}">${x}</button>`).join('')}</div>
        <p class="obnote">${meet?`We contact you to agree on a public place near you.`:`We let you know 30 minutes before arriving.`} The device is tested in front of you and paid on the spot, ${sell.pay==='cash'?'in cash':'by Interac e-Transfer'}.</p>
      </div>
      <button class="btn wide" style="margin-top:14px" data-sellaccept ${sell.slot?'':'disabled'}>${meet?'Confirm meetup':'Confirm pickup'}${sell.slot?' · '+sell.slot:''}</button>`
      :`
      <div class="nextsteps">
        <div><i>1</i><b>Check your inbox</b><p>A prepaid label and a QR code reach you within the hour, by email or text. No printer? Show the QR code at the counter.</p></div>
        <div><i>2</i><b>Drop it off</b><p>Any Canada Post, Purolator or UPS location. Keep the receipt for tracking.</p></div>
        <div><i>3</i><b>Get paid</b><p>Tested within two business days of arrival. If it matches, the e-Transfer goes out the same day. If not, we offer a new price first, and send it back free if you say no.</p></div>
      </div>
      <button class="btn wide line" style="margin-top:14px" data-sellaccept>Resend my label</button>`}

      <div class="card2" style="margin-top:18px">
        <h3>Before you hand it over</h3>
        <ul class="qlines" style="margin:0">
          <li><span>Sign out of iCloud or Google</span><b><a class="seclink" href="#/care/icloud">How</a></b></li>
          <li><span>Erase it and remove the SIM</span><b><a class="seclink" href="#/care/wipe">How</a></b></li>
          <li><span>Photo ID ready${pick?' for the pickup':' (a copy goes in the box)'}</span><b></b></li>
        </ul>
      </div>
      <button class="backlink" style="margin-top:16px" data-sellreset>Start over</button>`;
  }

  if(sell.step===6){
    const r=store.get('records',[]).find(x=>x.ref===sell.ref);
    inner = r ? `<div class="donebox big" style="margin-top:14px"><b>Request received</b>
        <p>${r.handoff==='ship' ? 'Your prepaid label and QR code are on their way.' : (r.handoff==='meet' ? `We will confirm a public meeting place for ${r.slot?r.slot.replace(/^(Today|Tomorrow|Saturday)/,m=>m.toLowerCase()==='saturday'?'Saturday':m.toLowerCase()):'the time we agree'}.` : `We will be there ${r.slot?r.slot.replace(/^(Today|Tomorrow)/,m=>m.toLowerCase()).replace(/^Saturday/,'on Saturday'):'at the time we agree'}.`)} ${/@/.test(r.contact)?'Confirmation sent to':'We will text you at'} ${r.contact}.</p>
        <p class="ref">Reference <strong>${r.ref}</strong></p></div>
      <div class="card2" style="margin-top:16px">${r.devices.map(d=>`<div class="qrow"><span>${d.model}<small>${d.spec}</small></span><b>${money(d.value)}</b></div>`).join('')}
        <div class="qrow tot"><span>Total offer</span><b>${money(r.total)}</b></div></div>
      <a class="btn wide line" style="margin-top:14px" href="#/care/track">Track this request</a>
      <button class="backlink" style="margin-top:16px" data-sellreset>Sell another device</button>` : '';
  }
  const banner = sell.step===0 ? `
    <div class="sellban">
      <div class="shell">
        <h1>Sell your tech<br>in 60 seconds</h1>
        <p>A firm offer, held for 14 days.<br>Free pickup in Ottawa–Gatineau, or a prepaid label anywhere in Canada.</p>
      </div>
    </div>` : `
    <div class="sellslim"><div class="shell">Sell your device</div></div>`;
  return `${banner}
    <div class="shell" style="max-width:620px;padding-top:${sell.step===0?18:10}px;padding-bottom:30px">${inner}</div>`;
}

function pageCheckout(){
  if(!state.cart.length) return `<div class="shell"><div class="empty"><p style="color:var(--ink);font-size:16.5px;font-weight:700">Nothing to check out yet</p><a class="btn" href="#/shop" style="margin-top:14px">Shop devices</a></div></div>`;
  const sub=cartTotal(), ship=sub>=FREE_SHIP?0:14, tax=Math.round((sub+ship)*0.13), tot=sub+ship+tax;
  const count=state.cart.reduce((a,i)=>a+i.qty,0);
  return `<div class="shell co">
    <div class="crumbs pxcrumbs"><a href="#/">Home</a> / Checkout</div>
    <h1 class="coh1">Checkout</h1>
    <div class="cogrid">
      <aside class="cosum">
        <div class="cobox">
          <p class="colabel">Order summary · ${count} item${count>1?'s':''}</p>
          ${state.cart.map(i=>`<div class="coitem"><div class="coimg">${art(i.art,i.name,40)}${i.qty>1?`<i>${i.qty}</i>`:''}</div>
            <div><b>${i.name}</b><span>${optLine(i,GRADES[i.grade].label)}</span></div>
            <strong>${money(i.price*i.qty)}</strong></div>`).join('')}
          <dl class="cotot">
            <div><dt>Subtotal</dt><dd>${money(sub)}</dd></div>
            <div><dt>Shipping</dt><dd>${ship?money(ship):'Free'}</dd></div>
            <div><dt>HST (13%)</dt><dd>${money(tax)}</dd></div>
            <div class="big"><dt>Total</dt><dd><small>CAD</small> ${money(tot)}</dd></div>
          </dl>
          <ul class="coperks"><li>${ico('shield',16)}12-month warranty</li><li>${ico('rotate',16)}30-day free returns</li></ul>
        </div>
      </aside>
      <div class="coform">
        <p class="colabel">Express checkout</p>
        <div class="coexpress"><button class="xpay apple" onclick="toast('Apple Pay opens here on a live site')"> Pay</button><button class="xpay gpay" onclick="toast('Google Pay opens here on a live site')">G Pay</button></div>
        <div class="coor"><span>or</span></div>

        <h2 class="coh2">Contact</h2>
        <input class="field" id="coContact" autocomplete="email" placeholder="Email or phone number">
        <h2 class="coh2">Delivery</h2>
        <input class="field" id="coName" autocomplete="name" placeholder="Full name">
        <input class="field" id="coAddr" autocomplete="street-address" placeholder="Address">
        <input class="field" id="coCity" autocomplete="address-level2" placeholder="City, province, postal code">
        <div class="coship">${ico('truck',18)}<div><b>${ship?'Tracked delivery · '+money(ship):'Free tracked delivery'}</b><span>Arrives ${delivery().range}</span></div></div>
        <p class="err" id="coErr"></p>
        <button class="btn wide cobtn" id="payBtn">${ico('lock',16)} Pay ${money(tot)}</button>
        <div class="paytrust"><span>Visa</span><span>Mastercard</span><span>Amex</span><span>Interac</span><span>Apple Pay</span><span>Google Pay</span></div>
        <p class="cofine">Demo checkout. No payment is taken.</p>
      </div>
    </div>
  </div>`;
}

const CARE = {
  stolen:{s:'Photo ID and a lost-and-stolen check on every device we buy.', t:'Stolen devices and ID checks', b:`
    <p>A buyback business only works if people can trust that what it sells was not taken from someone. So we check before we pay, every time.</p>
    <ol class="steps-list">
      <li>Every seller shows government photo ID, at pickup or with the shipped device, and we keep a record against the serial number.</li>
      <li>We check the IMEI or serial against the carriers' lost and stolen database before any payment goes out.</li>
      <li>Devices must be signed out of iCloud, Google or Samsung accounts. A locked device is not bought until the owner removes the lock.</li>
      <li>A device that comes back flagged is held, not paid for, and the matter is referred to police.</li>
    </ol>
    <p>If your phone was stolen and you think it reached us, contact us with the serial number or IMEI and a police report number. We check our records the same day.</p>
    <a class="btn wide" href="#/care/contact">Report a stolen device</a>`},
  battery:{s:'Where to find battery health on iPhone, Galaxy and MacBook.', t:'How to check battery health', b:`
    <p>Battery health is the first thing that decides a device's value, ours and yours. Here is where to find it.</p>
    <h3>iPhone</h3>
    <p>Settings › Battery › Battery Health &amp; Charging. The number next to Maximum Capacity is what we mean by battery health. On iPhone 15 and newer, the same screen shows the cycle count.</p>
    <h3>Samsung Galaxy</h3>
    <p>Open the Samsung Members app › Support › Phone diagnostics › Battery status. It shows the battery life as Good, Normal or Weak.</p>
    <h3>MacBook</h3>
    <p>System Settings › Battery › the info button next to Battery Health. For the cycle count, hold Option, click the Apple menu › System Information › Power.</p>
    <p>Every device we sell has a battery at 80% health or better. Below that, we replace the battery before it goes on sale.</p>`},
  icloud:{s:'Sign out of iCloud or Google so the device can be sold.', t:'How to remove iCloud or Google lock', b:`
    <p>A phone still signed in to its owner's account is locked to them, even after a reset. Nobody can use it, including us. Remove the lock before you sell.</p>
    <h3>iPhone or iPad</h3>
    <ol class="steps-list">
      <li>Settings › your name at the top › Sign Out.</li>
      <li>Enter your Apple Account password to turn off Find My.</li>
      <li>If the device is already gone, sign in at iCloud.com › Find Devices, select it, and choose Remove This Device.</li>
    </ol>
    <h3>Samsung or other Android</h3>
    <ol class="steps-list">
      <li>Settings › Accounts and backup › Manage accounts.</li>
      <li>Remove your Google account and your Samsung account.</li>
      <li>Then reset the phone. Removing the accounts first is what lifts the lock.</li>
    </ol>`},
  wipe:{s:'Back up, sign out and erase in five steps.', t:'How to wipe your phone before selling', b:`
    <p>We erase every device we buy and log the erasure. Doing it yourself first means your data never leaves your hands.</p>
    <ol class="steps-list">
      <li><b>Back up.</b> iCloud or your computer for iPhone, Google or Samsung Cloud for Android.</li>
      <li><b>Unpair your watch</b> if you have an Apple Watch, so it keeps its own backup.</li>
      <li><b>Sign out</b> of iCloud or Google, as in our lock guide.</li>
      <li><b>Erase.</b> iPhone: Settings › General › Transfer or Reset iPhone › Erase All Content and Settings. Samsung: Settings › General management › Reset › Factory data reset.</li>
      <li><b>Take out the SIM card</b>, or delete the eSIM when the phone asks during the erase.</li>
    </ol>
    <p>Not sure you did it right? Send it anyway. We check, and we wipe again regardless.</p>`},
  grading:{s:'Excellent, Good and Fair describe looks only. Every grade is 100% functional.', t:'How grading works', b:`
    <p>Every device we sell is Deviceli Certified: 30 checks by hand, 100% functional, battery at 80% health or better, wiped and logged, 12 months of warranty. The grade only describes how it looks.</p>
    <ul class="hilites">
      <li><b>Excellent</b><span>Almost no signs of use. Flawless screen, micro-scratches on the body invisible from 20 cm.</span></li>
      <li><b>Good, about 9% less</b><span>Light signs of use. Flawless screen, light micro-scratches on the body invisible from 50 cm.</span></li>
      <li><b>Fair, about 18% less</b><span>Visible signs of use. Scratches or small dents on the body, light screen scratches visible only when it is on.</span></li>
    </ul>
    <p>If the device you receive looks worse than its grade, send it back. We pay the shipping.</p>`},
  warranty:{s:'12 months, parts and labour. We pay shipping both ways.', t:'Warranty claim', b:`
    <p>Every device is covered 12 months from delivery, parts and labour, against any hardware fault that is not accidental damage. We repair, replace or refund, and we pay shipping both ways.</p>
    <h3>Start a claim</h3>
    <p class="hint">Order number, device and a short description of the fault. We answer within one business day.</p>
    <div data-form="warranty">
      <input class="field" name="order" placeholder="Order number" data-req>
      <input class="field" name="email" placeholder="Email" data-req data-type="email">
      <textarea class="field" name="message" rows="3" placeholder="What is happening with the device?" data-req></textarea>
      <button class="btn wide" data-submit>Send the claim</button>
    </div>`},
  returns:{s:'30 days, free return shipping, no restocking fee.', t:'Start a return', b:`
    <p>30 days from delivery, in the condition you received it. No restocking fee, and we pay the return shipping. Refund lands within three business days of the device arriving.</p>
    <h3>Request a label</h3>
    <div data-form="returns">
      <input class="field" name="order" placeholder="Order number" data-req>
      <input class="field" name="email" placeholder="Email" data-req data-type="email">
      <button class="btn wide" data-submit>Email me a return label</button>
    </div>`},
  track:{s:'Find your order with its reference, email or phone number.', t:'Track an order', b:`
    <p>Orders placed before 2pm on a business day ship the same day, tracked. You also get the tracking number by email as soon as the label is printed.</p>
    <div data-form="track">
      <input class="field" name="q" placeholder="Reference number, email or phone" data-req>
      <button class="btn wide" data-submit>Find it</button>
      <div class="trackout"></div>
    </div>`},
  data:{s:'Every device we buy is erased and the wipe is logged.', t:'Data wiping', b:`
    <p>Every device we buy is wiped to factory state and the wipe is logged against the serial number. Nothing is resold before that log exists.</p>
    <h3>Before you send us a device</h3>
    <ol class="steps-list">
      <li>Back up what you want to keep.</li>
      <li>Sign out of iCloud, or remove your Google account. We cannot process a device that is still account-locked.</li>
      <li>Erase all content and settings if you can. If you cannot, we do it on arrival.</li>
    </ol>`},
  pickup:{s:'Free pickup in Ottawa–Gatineau for devices you sell us.', t:'Local pickup for sellers', b:`
    <p>For devices we buy, we come to you. Free pickup across Ottawa, Gatineau and the surrounding area, often the same day you accept the offer.</p>
    <p>There is no storefront to visit. Everything we sell ships to you, tracked.</p>
    <ul class="hilites">
      <li><b>How pickup works</b><span>Accept the offer and choose a window. We test the device in front of you and pay on the spot, in cash or by Interac e-Transfer.</span></li>
      <li><b>Have photo ID ready</b><span>We log every device we buy against the seller's photo ID, and share those records with police on request.</span></li>
      <li><b>Outside the region</b><span>A prepaid label reaches you by email. We cover the postage, both directions if you decline a revised offer.</span></li>
    </ul>`},
  contact:{s:'A real person answers, usually within one business day.', t:'Contact us', b:`
    <p>A real person answers, usually within one business day. We speak English and French.</p>
    <div data-form="contact">
      <input class="field" name="name" placeholder="Your name" data-req>
      <input class="field" name="email" placeholder="Email or phone number" data-req data-type="contact">
      <textarea class="field" name="message" rows="3" placeholder="How can we help?" data-req></textarea>
      <button class="btn wide" data-submit>Send</button>
    </div>`},
  privacy:{s:'What we collect, why, and how to have it deleted.', t:'Privacy', b:`
    <p>We collect only what an order or a buyback needs: your name, email or phone, and a delivery address. For devices we buy, we also record the serial number or IMEI and the seller's photo ID.</p>
    <ul class="steps-list">
      <li>We use it to deliver, support and warranty your order, and to pay you for a device you sell.</li>
      <li>We never sell your information. Payment details are handled by the payment provider, not stored by us.</li>
      <li>Buyback ID records are kept to prevent the resale of stolen devices and shared with police on request.</li>
      <li>To see or delete what we hold about you, <a class="seclink" href="#/care/contact">contact us</a>.</li>
    </ul>`},
  terms:{s:'Prices, warranty, returns and buyback offers in plain terms.', t:'Terms', b:`
    <ul class="steps-list">
      <li>Prices are in Canadian dollars. HST is added at checkout.</li>
      <li>Every device is covered 12 months from delivery against hardware faults that are not accidental damage.</li>
      <li>You can return a device within 30 days of delivery, in the condition you received it. We pay the return shipping.</li>
      <li>A buyback offer is held 14 days and paid in full if the device matches your description. If it does not, we offer a revised price, and return the device free if you decline.</li>
      <li>By selling a device, you confirm that you own it and that it is not lost, stolen or financed with a carrier we do not accept.</li>
    </ul>`},
  business:{s:'Volume orders and fleet buyback for businesses.', t:'Business and bulk', b:`
    <p>Ten devices or a hundred. Volume pricing, net terms for repeat accounts, and one contact who answers. We also buy back fleets when you refresh.</p>
    <div data-form="business">
      <input class="field" name="company" placeholder="Company" data-req>
      <input class="field" name="email" placeholder="Work email or phone" data-req data-type="contact">
      <textarea class="field" name="message" rows="3" placeholder="What do you need, and how many?" data-req></textarea>
      <button class="btn wide" data-submit>Talk to us</button>
    </div>`}
};

function pageCare(topic){
  CARE.track = {s:'Your order status link is in your confirmation email.', t:'Track an order', b:`<p>Every order confirmation email has a link to its live status and tracking number. You can also sign in to your account to see all your orders.</p><a class="btn wide" href="/account">Go to my account</a>`};
  CARE.returns = {s:'30 days, free return shipping, no restocking fee.', t:'Start a return', b:`<p>30 days from delivery, in the condition you received it. No restocking fee, and we pay the return shipping. Refund lands within three business days of the device arriving.</p><a class="btn wide" href="/account">Request a return from my account</a>`};

  const keys=['warranty','returns','track','grading','pickup','battery','icloud','wipe','data','stolen','contact','business','privacy','terms'].filter(x=>CARE[x]);
  const k = CARE[topic] ? topic : null;
  const body = k ? `
    <a class="backlink" href="#/care">‹ All help topics</a>
    <h1 class="carehead">${CARE[k].t}</h1>
    <div class="carebody">${CARE[k].b}</div>` : `
    <h1 class="carehead">How can we help?</h1>
    ${[['Your order',['track','returns','warranty','grading']],['Selling to us',['pickup','battery','icloud','wipe','data','stolen']],['Get in touch',['contact','business']],['Policies',['privacy','terms']]].map(([g,ks])=>`
    <p class="cglabel">${g}</p>
    <div class="cglist">${ks.filter(x=>CARE[x]).map(x=>`<a href="#/care/${x}"><span><b>${CARE[x].t}</b><small>${CARE[x].s}</small></span><i aria-hidden="true">›</i></a>`).join('')}</div>`).join('')}`;
  return `<div class="sell-hero"><div class="shell"><h1>Deviceli Care</h1><p>Help with your order, your warranty and selling your device.</p></div></div>
    <div class="shell" style="max-width:680px;padding-top:22px;padding-bottom:36px">${body}
    <div style="height:22px"></div>
    ${tradeBanner(false)}
    </div>`;
}

function pageDone(ref){
  const r=store.get('records',[]).find(x=>x.ref===ref);
  if(!r) return `<div class="shell"><div class="empty"><p>We could not find that order on this device.</p><a class="btn" href="#/care/track">Track an order</a></div></div>`;
  return `<div class="shell" style="max-width:560px;padding-top:30px;padding-bottom:44px">
    <div class="donebox big"><b>Thank you, ${r.name.split(' ')[0]}</b>
      <p>Your order is placed. Confirmation goes to ${r.contact}.</p>
      <p class="ref">Order <strong>${r.ref}</strong></p></div>
    <div class="card2" style="margin-top:16px">
      ${r.items.map(i=>`<div class="qrow"><span>${i.name}<small>${optLine(i,i.grade)} · ×${i.qty}</small></span><b>${money(i.price*i.qty)}</b></div>`).join('')}
      <div class="qrow"><span>Shipping</span><b>${r.shipping?money(r.shipping):'Free'}</b></div>
      <div class="qrow"><span>HST (13%)</span><b>${money(r.tax)}</b></div>
      <div class="qrow tot"><span>Total</span><b>${money(r.total)}</b></div>
    </div>
    <div class="eta" style="margin-top:14px">${ico('truck',18)}<div><b>Arrives ${delivery().range}</b><span>Shipping to ${r.address}, ${r.city}.</span></div></div>
    <a class="btn wide" style="margin-top:16px" href="#/shop">Keep shopping</a>
  </div>`;
}

function pageAccount(){
  const mine = state.lookup ? findRecords(state.lookup) : [];
  return `<div class="shell" style="max-width:560px;padding-top:26px;padding-bottom:40px">
    <h1 style="font-size:26px;letter-spacing:-.035em;margin:0 0 6px">Your orders and requests</h1>
    <p style="color:var(--muted);margin:0 0 20px">Enter the email or phone number you used, or a reference number.</p>
    <input class="field" id="lookupQ" placeholder="Email, phone or reference" value="${state.lookup||''}">
    <button class="btn wide" data-lookup>Show my orders</button>
    <div style="margin-top:18px">${state.lookup ? (mine.length ? mine.map(recordCard).join('') : `<p class="hint">Nothing found for “${state.lookup}” on this device.</p>`) : ''}</div>
    <p class="cglabel" style="margin-top:28px">Quick help</p>
    <div class="cglist">
      <a href="#/care/track"><span><b>Track an order</b><small>Find it by reference, email or phone</small></span><i aria-hidden="true">›</i></a>
      <a href="#/care/returns"><span><b>Start a return</b><small>30 days, free return shipping</small></span><i aria-hidden="true">›</i></a>
      <a href="#/care/warranty"><span><b>Warranty claim</b><small>12 months, parts and labour</small></span><i aria-hidden="true">›</i></a>
      <a href="#/care/contact"><span><b>Contact us</b><small>A real person, usually within one business day</small></span><i aria-hidden="true">›</i></a>
    </div>
  </div>`;
}


/* =========================================================
   Wholesale — resellers and repair shops
   ========================================================= */
/* ---------- Wholesale: graded lots, per-unit reports ---------- */
const WS_GRADES = {
  A:{name:'Grade A', shop:'Excellent in our shop', pip:'', looks:'Like new. No marks you can see at arm\u2019s length.', glass:'Perfect', func:'Fully working', batt:'80%+'},
  B:{name:'Grade B', shop:'Good in our shop', pip:'good', looks:'Light micro-scratches on the frame or back.', glass:'No cracks', func:'Fully working', batt:'80%+'},
  C:{name:'Grade C', shop:'Fair in our shop', pip:'fair', looks:'Visible scuffs and small dents on the body.', glass:'No cracks', func:'Fully working', batt:'80%+'},
  D:{name:'Grade D', shop:'Wholesale only', pip:'crack', looks:'Cracked glass, for repair shops. Display works.', glass:'Cracked', func:'All but glass', batt:'Per unit'}
};
const WS_D_CATS = ['iphone','android','ipad','watch'];
const WS_MOQ = 5;
function wsStock(p){ return {A:99,B:99,C:99,D:WS_D_CATS.includes(p.cat)?99:0};
  const s=p.stock||0, h=[...p.id].reduce((a,c)=>a+c.charCodeAt(0),0);
  const A=Math.round(s*.35), B=Math.round(s*.4), C=Math.max(0,s-A-B);
  const D=WS_D_CATS.includes(p.cat)&&s>0 ? h%4 : 0;
  return {A,B,C,D};
}
const wsKey = (id,g) => id+'|'+g;
function wsLines(){
  return Object.entries(state.rfq||{}).filter(([,q])=>q>0).map(([k,q])=>{ const [id,g]=k.split('|'); const p=P.find(x=>x.id===id)||{}; return {k,id,g,q,name:p.name}; });
}
function wsCSV(){
  const rows=[['Model','Category','Capacities','Grade A','Grade B','Grade C','Grade D','Total']];
  P.forEach(p=>{ const st=wsStock(p); rows.push([p.name,(CATS.find(c=>c.id===p.cat)||{}).label,isCapacity(p.storage[0])?p.storage.join(' / '):'',st.A,st.B,st.C,st.D,st.A+st.B+st.C+st.D]); });
  const csv=rows.map(r=>r.map(v=>'"'+String(v).replace(/"/g,'""')+'"').join(',')).join('\n');
  try{
    const url=URL.createObjectURL(new Blob([csv],{type:'text/csv'}));
    const a=document.createElement('a'); a.href=url; a.download='deviceli-wholesale-stock.csv'; document.body.appendChild(a); a.click(); a.remove();
    setTimeout(()=>URL.revokeObjectURL(url),1000);
  }catch(e){ toast('Download is not available here'); }
}
function wsRoute(){               // re-render without losing what was typed in the quote form
  const box=document.querySelector('[data-form="wholesale"]'), keep={};
  if(box&&box.querySelectorAll) box.querySelectorAll('[name]').forEach(f=>keep[f.name]=f.value);
  route();
  const nb=document.querySelector('[data-form="wholesale"]');
  if(nb&&nb.querySelectorAll) nb.querySelectorAll('[name]').forEach(f=>{ if(keep[f.name]){ f.value=keep[f.name]; if(f.tagName==='SELECT') f.classList.add('set'); } });
}
function pageWholesale(){
  state.rfq = state.rfq || {}; state.wsg = state.wsg || {};
  const cat = state.wscat || '';
  const lines = wsLines(), units = lines.reduce((a,l)=>a+l.q,0);
  const list = P.filter(p=>!cat||p.cat===cat);
  const toStock = `document.getElementById('wsstock').scrollIntoView({behavior:'smooth',block:'start'})`;
  const rows = list.map(p=>{
    const st=wsStock(p), total=st.A+st.B+st.C+st.D;
    const avail=Object.keys(WS_GRADES).filter(g=>st[g]>0);
    const g = avail.includes(state.wsg[p.id]) ? state.wsg[p.id] : avail[0];
    const q = g ? (state.rfq[wsKey(p.id,g)]||0) : 0;
    return `<div class="wsrow ${q?'has':''}">
      <div class="wsitem"><div class="wsimg">${art(p.art,p.name,44)}</div><div><b>${p.name}</b><span>${isCapacity(p.storage[0])?p.storage.join(' · '):p.colors.map(c=>c[0]).join(' · ')}</span></div></div>
      <div class="wstot">Ask for stock</div>
      ${total?`<div class="wsgr" role="group" aria-label="Grade for ${p.name}">${Object.keys(WS_GRADES).map(k=>`<button class="${k===g?'on':''}" data-wsgrade="${wsKey(p.id,k)}" ${st[k]?'':'disabled'} aria-label="${WS_GRADES[k].name}, ${st[k]} available"><b>${k}</b></button>`).join('')}</div>
      <div class="qty wsq"><button data-rfqdec="${wsKey(p.id,g)}" aria-label="Fewer" ${q?'':'disabled'}>−</button><span>${q}</span><button data-rfqinc="${wsKey(p.id,g)}" aria-label="More" ${q>=st[g]?'disabled':''}>+</button></div>`:'<div></div><div></div>'}
    </div>`;
  }).join('');
  const short = Math.max(0, WS_MOQ-units);
  return `
  <div class="bizhero wshero"><div class="wsin wsherogrid">
    <div>
      <p class="wskick">Deviceli Wholesale</p>
      <h1>Graded stock by the lot.</h1>
      <p class="wslede">For resellers, repair shops and businesses. Every unit is unlocked and comes with its IMEI, battery health and test report, before you pay.</p>
      <div class="slideacts wsacts"><button class="hbtn solid" onclick="${toStock}">Browse stock</button><button class="hlink" data-wscsv>Download stock list</button></div>
      <div class="wsfacts"><div><b>${WS_MOQ} units</b><span>Minimum order</span></div><div><b>1 day</b><span>To your quote</span></div><div><b>14 days</b><span>DOA cover</span></div></div>
    </div>
    <div class="wsvis" aria-hidden="true">
      <div class="wsvcard">
        <div class="wsvimgs"><span>${art('mbp14_black','',160)}</span><span>${art('ipadair_blue','',120)}</span><span>${art('p16_green','',90)}</span></div>
        <div class="wsvrow"><span>Unlocked</span><span>IMEI checked</span><span>Battery 80%+</span></div>
      </div>
    </div>
  </div></div>

  <div class="wsin wsbody">
    <section class="wssec">
      <h2 class="wsh2">How it works</h2>
      <ol class="wssteps">
        <li><i>1</i><b>Build your lot</b><span>Pick models and grades from the stock list. Mix freely, ${WS_MOQ} units minimum.</span></li>
        <li><i>2</i><b>Get your quote</b><span>A per-unit price in CAD, with the IMEI list and a test report for every unit.</span></li>
        <li><i>3</i><b>Pay and receive</b><span>Interac e-Transfer or wire. Collect in Ottawa–Gatineau, or insured shipping across Canada.</span></li>
      </ol>
    </section>

    <section class="wssec">
      <h2 class="wsh2">Grades</h2>
      <p class="wssub">Grades describe looks only. A, B and C are fully working, the same units we sell in our shop. D is for repair shops.</p>
      <div class="wsgrades">${Object.entries(WS_GRADES).map(([k,g])=>`<div class="wsg">
        <div class="wsghead"><span class="wsbadge ${g.pip}">${k}</span><div><b>${g.name}</b><small>${g.shop}</small></div></div>
        <p>${g.looks}</p>
        <dl><div><dt>Glass</dt><dd>${g.glass}</dd></div><div><dt>Function</dt><dd>${g.func}</dd></div><div><dt>Battery</dt><dd>${g.batt}</dd></div></dl>
      </div>`).join('')}</div>
    </section>

    <section class="wssec wsreport">
      <div>
        <h2 class="wsh2">Every unit, reported</h2>
        <p class="wssub">Nothing ships without its report. You get the full list with your quote.</p>
        <ul class="wsincl">
          <li>${ico('scan',20)}<span><b>Clean IMEI</b>Checked against the carriers’ lost and stolen database</span></li>
          <li>${ico('lock',20)}<span><b>No locks</b>Unlocked, no iCloud, Google, Samsung or MDM</span></li>
          <li>${ico('battery',20)}<span><b>Battery measured</b>Health listed on every unit</span></li>
          <li>${ico('parts',20)}<span><b>Parts declared</b>Original or replaced, never hidden</span></li>
          <li>${ico('test',20)}<span><b>30-point test</b>Screen, cameras, audio, charging, sensors</span></li>
          <li>${ico('erase',20)}<span><b>Data erased</b>Erasure logged per serial number</span></li>
        </ul>
      </div>
      <div class="wssample" aria-label="Sample unit report">
        <div class="wsshead"><div><small>Unit report</small><b>iPhone 15 Pro, 256GB</b></div><em>Sample</em></div>
        <dl>
          <div><dt>IMEI</dt><dd class="mono">35 •••••• •••• 4127</dd></div>
          <div><dt>Grade</dt><dd><span class="wsbadge sm good">B</span></dd></div>
          <div><dt>Battery health</dt><dd>88%</dd></div>
          <div><dt>Parts</dt><dd>All original</dd></div>
          <div><dt>Lock status</dt><dd><span class="wspass">Clean</span></dd></div>
          <div><dt>Functional test</dt><dd><span class="wspass">30 / 30</span></dd></div>
          <div><dt>Data</dt><dd><span class="wspass">Erased</span></dd></div>
        </dl>
      </div>
    </section>

    <section class="wssec" id="wsstock">
      <div class="wsstockhead"><h2 class="wsh2">Stock list</h2><button class="wscsv" data-wscsv>Download CSV</button></div>
      <p class="wssub">Pick a grade, then the quantity. Prices are per unit and quoted by lot.</p>
      <div class="wschips">${[['all','All'],...CATS.map(c=>[c.id,c.label])].map(([id,l])=>`<button class="${(id==='all'?!cat:cat===id)?'on':''}" data-wscat="${id}">${l}</button>`).join('')}</div>
      <div class="wslist">
        <div class="wslhead"><span>Model</span><span>Stock</span><span>Grade</span><span>Quantity</span></div>
        ${rows||'<p class="wssub" style="padding:18px">Nothing in this category right now. Tell us what you need below.</p>'}
      </div>
    </section>

    <section class="wssec" id="wslot">
      <h2 class="wsh2">Request a quote</h2>
      <div class="wsquote">
        <div class="wslot">
          <p class="wslabel">Your lot</p>
          ${lines.length?`${lines.map(l=>`<div class="wsline"><span>${l.name}<small>${WS_GRADES[l.g].name}</small></span><b>× ${l.q}</b><button data-rfqrm="${l.k}" aria-label="Remove">×</button></div>`).join('')}
            <div class="wsline tot"><span>${units} unit${units>1?'s':''}</span><small>${lines.length} line${lines.length>1?'s':''}</small></div>
            <div class="wsmeter"><i style="width:${Math.min(100,units/WS_MOQ*100)}%"></i></div>
            <p class="wsmoq ${short?'':'ok'}">${short?`Add ${short} more unit${short>1?'s':''} to reach the ${WS_MOQ}-unit minimum.`:'Minimum reached. Ready to quote.'}</p>`
          :`<div class="wsempty"><p>Your lot is empty.</p><button class="seclink" onclick="${toStock}">Browse the stock list</button><small>Or skip it and describe what you need.</small></div>`}
        </div>
        <div data-form="wholesale" class="wsform">
          <div class="wsf2"><input class="field" name="company" placeholder="Business name" autocomplete="organization" data-req>
          <input class="field" name="name" placeholder="Your name" autocomplete="name" data-req></div>
          <div class="wsf2"><input class="field" name="email" placeholder="Work email or phone" data-req data-type="contact">
          <input class="field" name="bn" placeholder="Business number (optional)"></div>
          <div class="wsf2"><select class="field" onchange="this.classList.toggle('set',!!this.value)" name="type" aria-label="Type of business"><option value="">Type of business</option><option>Reseller or online store</option><option>Repair shop</option><option>Retail store</option><option>Exporter</option><option>Other</option></select>
          <select class="field" onchange="this.classList.toggle('set',!!this.value)" name="volume" aria-label="Units per month"><option value="">Units per month</option><option>5 to 20</option><option>20 to 100</option><option>More than 100</option></select></div>
          <textarea class="field" name="message" rows="3" placeholder="Capacities, colours, anything specific"></textarea>
          <button class="btn wide" data-submit>${units?`Request a quote · ${units} unit${units>1?'s':''}`:'Request a quote'}</button>
          <p class="wsfine">A priced quote and the IMEI list follow within one business day.</p>
        </div>
      </div>
    </section>

    <section class="wssec wsinfo">
      <div>
        <h2 class="wsh2">Terms</h2>
        <dl class="wsterms">
          <div><dt>Minimum order</dt><dd>${WS_MOQ} units, any mix of models and grades</dd></div>
          <div><dt>Prices</dt><dd>Per unit in CAD, quoted by lot. HST added for Canadian buyers</dd></div>
          <div><dt>Payment</dt><dd>Interac e-Transfer or wire before release. Net terms for approved repeat accounts</dd></div>
          <div><dt>Delivery</dt><dd>Collect in Ottawa–Gatineau, or tracked, insured shipping across Canada. Export on request</dd></div>
          <div><dt>Dead on arrival</dt><dd>Report within 14 days of delivery with the IMEI. Replaced, credited or refunded</dd></div>
          <div><dt>Wrong grade</dt><dd>Same 14 days. We credit the difference or take the unit back</dd></div>
        </dl>
      </div>
      <div>
        <h2 class="wsh2">Questions</h2>
        <div class="wsfaq">
          <details><summary>Can I buy one or two units?</summary><p>Yes, through the <a class="seclink" href="#/shop">shop</a>, with the same grades and a 12-month warranty.</p></details>
          <details><summary>Is Grade D tested?</summary><p>Yes. Display, touch, cameras, buttons and charging all work. The cracked glass is the only fault, and it is on the report.</p></details>
          <details><summary>Do you also buy stock?</summary><p>Yes. We buy retired phones, tablets and laptops from businesses. See <a class="seclink" href="#/care/business">fleet buyback</a>.</p></details>
          <details><summary>Can I get specific capacities or colours?</summary><p>Yes. Add them in the notes and the quote lists exactly what we can supply.</p></details>
        </div>
      </div>
    </section>
    ${units?`<button class="wslotbar" onclick="document.getElementById('wslot').scrollIntoView({behavior:'smooth',block:'start'})"><span>Your lot</span><b>${units} unit${units>1?'s':''}${short?` · ${short} more to reach ${WS_MOQ}`:''}</b><em>Review ›</em></button>`:''}
  </div>`;
}

/* =========================================================
   Company — who is behind Deviceli
   ========================================================= */
function pageCompany(){
  const steps=[
    ['tag','Bought back','From people and businesses, at a firm price held 14 days.'],
    ['scan','Checked','Seller ID and the lost and stolen database, before any payment.'],
    ['test','Tested','30 checks by hand. Battery measured, data erased and logged.'],
    ['parts','Refurbished','Worn parts replaced, then graded Excellent, Good or Fair.'],
    ['truck','Sold again','Through the shop, or by the lot through Wholesale.'],
    ['leaf','Recycled','What cannot be reused goes to a certified e-waste recycler.']
  ];
  return `
  <div class="bizhero wshero"><div class="wsin wsherogrid">
    <div>
      <p class="wskick">About Deviceli</p>
      <h1>Good tech deserves a second life.</h1>
      <p class="wslede">We buy phones, tablets and computers people no longer use, test and repair them by hand, and sell them again with the promises you expect from new.</p>
      <div class="slideacts wsacts"><a class="hbtn solid" href="#/shop">Shop refurbished</a><a class="hlink" href="#/sell">Sell a device</a></div>
    </div>
    <div class="copromise">
      <p>The Deviceli promise</p>
      <ul>
        <li>${ico('shield',20)}<span><b>12-month warranty</b>Parts and labour, on every device</span></li>
        <li>${ico('rotate',20)}<span><b>30-day returns</b>Free return shipping, full refund</span></li>
        <li>${ico('battery',20)}<span><b>Battery at 80% or better</b>Measured, never guessed</span></li>
        <li>${ico('lock',20)}<span><b>Clean and erased</b>Checked for theft, data wiped and logged</span></li>
      </ul>
    </div>
  </div></div>

  <div class="wsin wsbody">
    <section class="wssec comission">
      <p class="cokick">Why we exist</p>
      <h2 class="costate">Most phones and laptops are replaced long before they stop working. Deviceli keeps them in use, and makes buying one feel as safe as buying new.</h2>
      <p class="wssub">Every device we sell has been bought back, checked, tested and graded by us, not by an anonymous marketplace seller. That is how we can stand behind each one.</p>
    </section>

    <section class="wssec">
      <h2 class="wsh2">What we stand for</h2>
      <div class="covalues">
        <div><b>Honest grades</b><p>A grade describes looks only, and every grade works the same. If your device looks worse than its grade, send it back at our cost.</p></div>
        <div><b>Tested by hand</b><p>Thirty checks on every device, battery at 80% health or better, before anything reaches the shelf.</p></div>
        <div><b>Fair both ways</b><p>Sellers get a firm offer held for 14 days. Buyers pay well below new, with a 12-month warranty.</p></div>
        <div><b>Nothing wasted</b><p>What cannot be resold is used for parts or sent to a certified e-waste recycler.</p></div>
      </div>
    </section>

    <section class="wssec">
      <h2 class="wsh2">How a device moves through Deviceli</h2>
      <p class="wssub">One loop, run in-house from start to finish.</p>
      <ol class="coloop">${steps.map((x,i)=>`<li><span class="coico">${ico(x[0],22)}</span><small>${String(i+1).padStart(2,'0')}</small><b>${x[1]}</b><p>${x[2]}</p></li>`).join('')}</ol>
    </section>

    <section class="wssec">
      <h2 class="wsh2">Work with us</h2>
      <div class="codoors">
        <a href="#/shop"><small>For you</small><b>Shop refurbished</b><p>iPhone, Galaxy, iPad, MacBook and more, graded and warrantied.</p><span>Shop now ›</span></a>
        <a href="#/sell"><small>For you</small><b>Sell your device</b><p>A firm offer in 60 seconds. Free pickup in Ottawa–Gatineau or a prepaid label.</p><span>Get an offer ›</span></a>
        <a href="#/wholesale"><small>For business</small><b>Wholesale</b><p>Graded, unlocked stock by the lot, with a report for every unit.</p><span>See stock ›</span></a>
        <a href="#/care/business"><small>For business</small><b>Fleet buyback</b><p>Retiring laptops, phones or tablets? We buy them back and erase every one.</p><span>Talk to us ›</span></a>
      </div>
    </section>

    <section class="wssec cofacts">
      <div>
        <h2 class="wsh2">Company details</h2>
        <p class="wssub">Deviceli is the retail brand of MobileBuyback Inc., a federally incorporated Canadian company.</p>
        <div class="slideacts cocta"><a class="btn" href="#/care/contact">Contact us</a><a class="seclink" href="#/care">Help centre</a></div>
      </div>
      <dl class="wsterms">
        <div><dt>Legal name</dt><dd>MobileBuyback Inc.</dd></div>
        <div><dt>Brand</dt><dd>Deviceli</dd></div>
        <div><dt>Incorporation</dt><dd>Federal, 2026</dd></div>
        <div><dt>Business number</dt><dd>72282 5239</dd></div>
        <div><dt>Head office</dt><dd>Ottawa, Ontario</dd></div>
        <div><dt>Service area</dt><dd>Pickup in Ottawa–Gatineau, shipping across Canada</dd></div>
        <div><dt>Languages</dt><dd>English and French</dd></div>
      </dl>
    </section>
  </div>`;
}


/* =========================================================
   Forms and records
   Every submission is checked, gets a reference, and is kept on this device.
   Set API_URL to your server (for example your Smart Buyback PHP endpoint)
   and each submission is also sent there as JSON: POST {API_URL}/{kind}
   ========================================================= */
const API_URL = '';
const _mem = {};   // used when the browser blocks storage (private mode, some previews)
const store = {
  get(k,d){ try{ const v=localStorage.getItem('dv_'+k); if(v) return JSON.parse(v); }catch(e){} return (k in _mem)?_mem[k]:d; },
  set(k,v){ _mem[k]=v; try{ localStorage.setItem('dv_'+k, JSON.stringify(v)); }catch(e){} }
};
const PREFIX={order:'DV',sell:'SB',warranty:'WR',returns:'RT',contact:'MSG',business:'BIZ',wholesale:'WS',newsletter:'NL'};
function newRef(kind){ const n=(Date.now()%1e6).toString(36).toUpperCase().padStart(4,'0'); return (PREFIX[kind]||'REF')+'-'+n+Math.random().toString(36).slice(2,4).toUpperCase(); }
function record(kind, data){
  const entry={ref:newRef(kind), kind, at:new Date().toISOString(), status:'Received', ...data};
  const all=store.get('records',[]); all.unshift(entry); store.set('records',all.slice(0,100));
  if(API_URL){ try{ fetch(API_URL.replace(/\/$/,'')+'/'+kind,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(entry)}).catch(()=>{}); }catch(e){} }
  return entry;
}
function findRecords(q){ q=(q||'').trim().toLowerCase(); if(!q) return [];
  return store.get('records',[]).filter(r=>r.ref.toLowerCase()===q || (r.email||'').toLowerCase()===q || (r.contact||'').toLowerCase()===q); }
const isEmail=v=>/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v||'');
const isPhone=v=>(v||'').replace(/\D/g,'').length>=10;
const KIND_LABEL={order:'Order',sell:'Buyback request',warranty:'Warranty claim',returns:'Return',contact:'Message',business:'Business enquiry',wholesale:'Wholesale quote',newsletter:'Newsletter'};
function recordCard(r){
  const when=new Date(r.at).toLocaleDateString('en-CA',{month:'short',day:'numeric',year:'numeric'});
  const what = r.kind==='order' ? `${r.items.length} item${r.items.length>1?'s':''} · ${money(r.total)}`
             : r.kind==='sell' ? `${r.devices.map(d=>d.model).join(', ')} · ${money(r.total)} · ${({pickup:'Pickup',meet:'Meetup',ship:'Mail-in'})[r.handoff]||''}${r.slot?' · '+r.slot:''}`
             : r.kind==='wholesale' && (r.items||[]).length ? `${r.units} units · ${r.items.map(i=>i.name+' '+i.grade.replace('Grade ','')+' ×'+i.qty).join(', ')}`.slice(0,120)
             : (r.message||r.email||'').slice(0,80);
  return `<div class="rec"><div><b>${KIND_LABEL[r.kind]||r.kind}</b><span>${r.ref} · ${when}</span><p>${what}</p></div><em>${r.status}</em></div>`;
}
function doneBox(entry, line){
  return `<div class="donebox"><b>Received</b><p>${line}</p><p class="ref">Reference <strong>${entry.ref}</strong></p><a class="seclink" href="#/care/track">Track it</a></div>`;
}

/* a form is any element with data-form; fields need a name; data-req marks required ones */
function submitForm(btn){
  const box=btn.closest('[data-form]'); if(!box) return;
  const kind=box.dataset.form, data={}, errs=[];
  box.querySelectorAll('input[name],textarea[name],select[name]').forEach(f=>{
    const v=(f.value||'').trim(); data[f.name]=v;
    if(f.hasAttribute('data-req') && !v) errs.push(f.placeholder||f.name);
    if(v && f.dataset.type==='email' && !isEmail(v)) errs.push('a valid email');
    if(v && f.dataset.type==='contact' && !isEmail(v) && !isPhone(v)) errs.push('a valid email or phone number');
  });
  let err=box.querySelector('.formerr'); if(!err){ err=document.createElement('p'); err.className='err formerr'; btn.before(err); }
  if(errs.length){ err.textContent='Please add '+[...new Set(errs)].join(', ').toLowerCase()+'.'; return; }
  err.textContent='';
  if(kind==='track'){
    const hits=findRecords(data.q);
    box.querySelector('.trackout').innerHTML = hits.length
      ? hits.map(recordCard).join('')
      : `<p class="hint">Nothing found for “${data.q}” on this device. Orders placed elsewhere are tracked by email: check your confirmation, or <a class="seclink" href="#/care/contact">contact us</a>.</p>`;
    return;
  }
  if(kind==='wholesale'){ data.items=wsLines().map(l=>({id:l.id,name:l.name,grade:WS_GRADES[l.g].name,qty:l.q})); data.units=data.items.reduce((a,i)=>a+i.qty,0); }
  const entry=record(kind,data);
  const line={warranty:'Your claim is with us. We reply within one business day.',returns:'A prepaid return label is on its way to your inbox.',contact:'Your message is with us. We reply within one business day.',business:'Thanks. We will be in touch within one business day.',wholesale:'Your request is in. A priced quote follows within one business day.',newsletter:'You are on the list.'}[kind]||'Thanks.';
  box.innerHTML = doneBox(entry,line);
  if(kind==='wholesale'){ state.rfq={}; }
}

/* ===== Shopify glue ===== */
Object.assign(IMG, window.DV_IMG||{});
if(window.DV_IMG && window.DV_IMG.boxshot) BOXSHOT=window.DV_IMG.boxshot;
const DV_ROOT = document.getElementById('dv-app');
const DV_VIEW = DV_ROOT ? DV_ROOT.dataset.view : '';
const DV_LINKS = {'#/':'/','#/shop':'/collections/all','#/sell':'/pages/sell','#/wholesale':'/pages/wholesale','#/company':'/pages/about',
  '#/account':'/account','#/checkout':'/cart','#/care':'/pages/help','#/care/contact':'/pages/contact','#/care/returns':'/account','#/care/track':'/account'};
const DV_COLL = {iphone:'iphone',android:'samsung',ipad:'ipad',mac:'macbook',watch:'watch',gaming:'gaming',audio:'airpods'};
function dvHref(h){
  if(DV_LINKS[h]) return DV_LINKS[h];
  let m=h.match(/^#\/care\/(\w+)/); if(m) return '/pages/help?topic='+m[1];
  m=h.match(/^#\/shop\/(\w+)/); if(m) return '/collections/'+(DV_COLL[m[1]]||m[1]);
  if(h.startsWith('#/shop')) return '/collections/all';
  return '/';
}
function dvFixLinks(root){ root.querySelectorAll('a[href^="#/"]').forEach(a=>a.setAttribute('href',dvHref(a.getAttribute('href')))); }
let DV_TOPIC = new URLSearchParams(location.search).get('topic') || '';
let DV_LASTKEY = '';
function route(){
  if(!DV_ROOT) return;
  let html='';
  if(DV_VIEW==='sell') html=pageSell();
  else if(DV_VIEW==='wholesale') html=pageWholesale();
  else if(DV_VIEW==='about') html=pageCompany();
  else html=pageCare(DV_TOPIC);
  DV_ROOT.innerHTML=html; dvFixLinks(DV_ROOT);
  const key = DV_VIEW==='sell' ? (sell.step+'|'+(sell.cat||'')+'|'+(sell.model||'')) : DV_VIEW+DV_TOPIC;
  if(DV_LASTKEY && key!==DV_LASTKEY){ const top=DV_ROOT.getBoundingClientRect().top+window.scrollY-90; window.scrollTo({top:Math.max(0,top),behavior:'instant'}); }
  DV_LASTKEY=key;
  const find=document.getElementById('modelFind');
  if(find) find.oninput=e=>{ sell.find=e.target.value; route(); const f=document.getElementById('modelFind'); if(f){ f.focus(); f.setSelectionRange(f.value.length,f.value.length); } };
}
function go(h){ if(h && h.startsWith('#/care/')){ DV_TOPIC=h.split('/')[2]; history.pushState({}, '', '/pages/help?topic='+DV_TOPIC); return route(); } location.href=dvHref(h); }
function renderCart(){} function openCart(){} function openMenu(){}
/* send every request to the store inbox through Shopify's contact form */
function dvText(entry){
  const lines=['Deviceli '+(KIND_LABEL[entry.kind]||entry.kind)+' '+entry.ref];
  const add=(k,v)=>{ if(v!==undefined&&v!==''&&v!==null) lines.push(k+': '+v); };
  add('Name',entry.name); add('Contact',entry.contact||entry.email); add('Company',entry.company); add('Business number',entry.bn);
  add('Type',entry.type); add('Volume',entry.volume); add('Order',entry.order); add('Device',entry.device);
  if(entry.devices) entry.devices.forEach((d,i)=>add('Device '+(i+1),d.model+' · '+d.spec+' · C$'+d.value));
  add('Total offer', entry.total!=null?'C$'+entry.total:'');
  add('Handover',entry.handoff); add('Slot',entry.slot); add('Paid by',entry.pay);
  if(entry.items) entry.items.forEach(i=>add('Line',(i.name||'')+' '+(i.grade||'')+' x'+(i.qty||1)));
  add('Message',entry.message);
  return lines.join('\n');
}
function dvSend(entry){
  const f=document.getElementById('dv-contact'); if(!f) return;
  const contact=entry.contact||entry.email||'';
  const email = isEmail(contact) ? contact : ('phone-'+String(contact).replace(/\D/g,'')+'@no-email.invalid');
  f.querySelector('[name="contact[email]"]').value=email;
  f.querySelector('[name="contact[name]"]').value=entry.name||entry.company||'';
  f.querySelector('[name="contact[phone]"]').value=isPhone(contact)&&!isEmail(contact)?contact:'';
  f.querySelector('[name="contact[body]"]').value=dvText(entry);
  const fd=new FormData(f);
  fetch(f.action,{method:'POST',body:fd,credentials:'same-origin'}).then(r=>{ if(/challenge/.test(r.url)) f.submit(); }).catch(()=>f.submit());
}
const _dvRecord = record;
record = function(kind,data){ const e=_dvRecord(kind,data); if(kind!=='newsletter') dvSend(e); return e; };

document.addEventListener('click',e=>{
  const t=e.target.closest('[data-submit],[data-lookup],[data-fav],[data-storage],[data-color],[data-shot],[data-grade],[data-rfqinc],[data-rfqdec],[data-rfqrm],[data-wsgrade],[data-wscat],[data-wscsv],[data-buybar],[data-inc],[data-dec],[data-rm],[data-close],[data-sellcat],[data-sellquick],[data-sellmodel],[data-sellcontract],[data-sellcarrier],[data-sellstorage],[data-sellgrade],[data-sellconn],[data-sellctrl],[data-sellbatt],[data-sellpay],[data-selladd],[data-sellrm],[data-sellhandoff],[data-sellslot],[data-selllock],[data-sellstep],[data-sellhelp],[data-sellreset],[data-sellaccept]');
  if(!t) return;
  const d=t.dataset;
  if(t.hasAttribute('data-submit')){ submitForm(t); return; }
  if(t.hasAttribute('data-lookup')){ const q=document.getElementById('lookupQ'); state.lookup=q?q.value.trim():''; return route(); }
  if(d.storage!=null&&d.storage!==''){ sel.storage=+d.storage; const y=window.scrollY||0; route(); window.scrollTo(0,y); return; }
  if(d.shot!=null&&d.shot!==''){ sel.shot=+d.shot; return route(); }
  if(d.color!=null&&d.color!==''){ sel.color=+d.color; sel.shot=0; const y=window.scrollY||0; route(); window.scrollTo(0,y); return; }
  if(d.grade){ sel.grade=d.grade; const y=window.scrollY||0; route(); window.scrollTo(0,y); return; }
  if(d.fav!=null && t.hasAttribute('data-fav')){ state.fav=d.fav; const y=window.scrollY||0; route(); window.scrollTo(0,y); return; }
  if(d.rfqinc){ state.rfq=state.rfq||{}; const [id,g]=d.rfqinc.split('|'); const p=P.find(x=>x.id===id); const max=p&&g?wsStock(p)[g]:99; state.rfq[d.rfqinc]=Math.min(max,(state.rfq[d.rfqinc]||0)+1); return wsRoute(); }
  if(d.rfqrm){ delete state.rfq[d.rfqrm]; return wsRoute(); }
  if(d.wsgrade){ const [id,g]=d.wsgrade.split('|'); state.wsg=state.wsg||{}; state.wsg[id]=g; return wsRoute(); }
  if(d.wscat){ state.wscat=d.wscat==='all'?'':d.wscat; return wsRoute(); }
  if(t.hasAttribute('data-wscsv')){ wsCSV(); return; }
  if(d.rfqdec){ state.rfq=state.rfq||{}; state.rfq[d.rfqdec]=Math.max(0,(state.rfq[d.rfqdec]||0)-1); return wsRoute(); }
  if(t.hasAttribute('data-buybar')){ const b=document.getElementById('addBtn'); if(b) b.click(); return; }
  if(d.inc){ state.cart.find(i=>i.key===d.inc).qty++; return renderCart(); }
  if(d.dec){ const i=state.cart.find(x=>x.key===d.dec); i.qty--; if(i.qty<1) state.cart=state.cart.filter(x=>x.key!==d.dec); return renderCart(); }
  if(d.rm){ state.cart=state.cart.filter(x=>x.key!==d.rm); return renderCart(); }
  if(t.hasAttribute('data-close')) return openCart(false);
  if(d.sellcat){ sell.cat=d.sellcat; sell.model=null; sell.find=''; sell.storage=null; sell.contract=null; sell.carrier=null; sell.grade=null; sell.step=1; return route(); }
  if(d.sellquick){ const [c,m]=d.sellquick.split('|'); sell.cat=c; sell.model=m; sell.find=''; sell.storage=null; sell.contract=null; sell.grade=null; sell.step=2; return route(); }
  if(d.sellmodel){ sell.model=d.sellmodel; sell.storage=null; sell.contract=null; sell.grade=null; sell.step=2; return route(); }
  if(d.sellcontract){ sell.contract=d.sellcontract; if(d.sellcontract==='no') sell.carrier=null; return route(); }
  if(d.sellcarrier!=null){ sell.carrier=d.sellcarrier||null; return route(); }
  if(d.sellstorage!=null&&d.sellstorage!==''){ sell.storage=+d.sellstorage; return route(); }
  if(d.sellgrade){ sell.grade=d.sellgrade; return route(); }
  if(d.sellconn){ sell.conn=d.sellconn; return route(); }
  if(d.sellctrl){ sell.ctrl=d.sellctrl; return route(); }
  if(d.sellbatt){ sell.batt=d.sellbatt; return route(); }
  if(d.sellpay){ sell.pay=d.sellpay; const n=document.getElementById('sellName'), c=document.getElementById('sellContact'); if(n) sell.name=n.value.trim(); if(c) sell.contact=c.value.trim(); return route(); }
  if(t.hasAttribute('data-selladd')){
    const cap=capList()[sell.storage], g=GRADES_SELL.find(x=>x.k===sell.grade);
    sell.basket=(sell.basket||[]).concat([{model:sell.model, spec:[cap?cap[0]:null,g?g.t:null].filter(Boolean).join(' · '), value:offerValue()}]);
    Object.assign(sell,{step:0,cat:null,model:null,find:'',contract:null,carrier:null,storage:null,batt:null,grade:null,conn:null,ctrl:null});
    return route();
  }
  if(d.sellrm!=null && d.sellrm!==''){ sell.basket=(sell.basket||[]).filter((_,i)=>i!==+d.sellrm); return route(); }
  if(d.sellhandoff){ sell.handoff=d.sellhandoff; const n=document.getElementById('sellName'), c=document.getElementById('sellContact'); if(n) sell.name=n.value.trim(); if(c) sell.contact=c.value.trim(); sell.emailErr=''; return route(); }
  if(d.sellslot){ sell.slot=d.sellslot; return route(); }
  if(t.hasAttribute('data-selllock')){
    const n=document.getElementById('sellName'), c=document.getElementById('sellContact');
    sell.name=n?n.value.trim():''; sell.contact=c?c.value.trim():'';
    const isEmail=/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(sell.contact), isPhone=sell.contact.replace(/\D/g,'').length>=10;
    if(!sell.name){ sell.emailErr='Add your name.'; return route(); }
    if(!isEmail && !isPhone){ sell.emailErr='Add an email or a phone number so we can reach you.'; return route(); }
    sell.emailErr=''; sell.step=5; return route();
  }

  if(d.sellstep!=null&&d.sellstep!==''){
    const el=document.getElementById('sellEmail'); if(el) sell.email=el.value;
    sell.step=+d.sellstep; return route();
  }
  if(t.hasAttribute('data-sellhelp')){ sell.help=!sell.help; return route(); }
  if(t.hasAttribute('data-sellreset')){ Object.assign(sell,{step:0,cat:null,model:null,find:'',contract:null,carrier:null,storage:null,batt:null,grade:null,email:'',phone:'',name:'',contact:'',handoff:'pickup',slot:null,conn:null,ctrl:null,pay:'etransfer',basket:[],emailErr:'',help:false}); return route(); }
  if(t.hasAttribute('data-sellaccept')){
    const cap=capList()[sell.storage], g=GRADES_SELL.find(x=>x.k===sell.grade);
    const devices=(sell.basket||[]).concat([{model:sell.model, spec:[cap?cap[0]:null,g?g.t:null].filter(Boolean).join(' · '), value:offerValue()}]);
    const entry=record('sell',{name:sell.name, contact:sell.contact, email:isEmail(sell.contact)?sell.contact:'', devices,
      total:devices.reduce((a,d)=>a+d.value,0), handoff:sell.handoff||'pickup', slot:sell.slot||'', pay:sell.pay||'etransfer',
      status: sell.handoff==='ship' ? 'Label sent' : 'Pickup booked'});
    sell.ref=entry.ref; sell.step=6; return route();
  }
});
route();
